// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"gb59R":[function(require,module,exports) {
require("13a07b7c90bd3ca").register(require("82e551bc0106d234").getBundleURL("c4cLN"), JSON.parse('["c4cLN","index.js","joS1N","EmailConfirmationWall.28f4a906.js","g9O5g","NotificationToast.31b92c6e.js"]'));

},{"13a07b7c90bd3ca":"fyJL2","82e551bc0106d234":"c7Tr5"}],"fyJL2":[function(require,module,exports) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"c7Tr5":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}],"8RSWf":[function(require,module,exports) {
var _auth0Sdk = require("./auth0-sdk");
const queue = window.CIAM || [];
window.CIAM = {
    push: (fn)=>{
        fn();
    },
    getIdToken: (0, _auth0Sdk.getIdToken),
    getAccessToken: (0, _auth0Sdk.getAccessToken),
    getUserInfo: (0, _auth0Sdk.getUserInfo),
    isAuthenticated: (0, _auth0Sdk.isAuthenticated),
    isEmailVerified: (0, _auth0Sdk.isEmailVerified),
    showEmailConfirmation: (0, _auth0Sdk.showEmailConfirmation),
    showSilentLoginNotification: (0, _auth0Sdk.showSilentLoginNotification),
    sendEmailVerification: (0, _auth0Sdk.sendEmailVerification),
    getUserSubscriptions: (0, _auth0Sdk.getUserSubscriptions)
};
if (Array.isArray(queue)) queue.forEach((fn)=>fn());
if (document.currentScript) {
    let clientId = document.currentScript.getAttribute("data-client-id");
    let brand = document.currentScript.getAttribute("data-brand");
    // @ts-ignore
    if (!clientId && typeof window.MEDIAHUIS !== "undefined" && window.MEDIAHUIS.config && window.MEDIAHUIS.config.auth0) // @ts-ignore
    clientId = window.MEDIAHUIS.config.auth0.clientId;
    // @ts-ignore
    if (!brand && typeof document !== "undefined") // @ts-ignore
    brand = document.title.indexOf("-") ? document.title.split(" - ")[1] : "";
    if (clientId && brand) {
        if (!document.getElementById("auth0_silent-login-root")) {
            var doc = document.createElement("div");
            doc.id = "auth0_silent-login-root";
            document.body.appendChild(doc);
        }
        (0, _auth0Sdk.showSilentLoginNotification)({
            clientId,
            brand
        });
    } else console.warn('Missing "data-client-id" or "data-brand" attribute');
}

},{"./auth0-sdk":"3ELjX"}],"3ELjX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @private
 * @param clientId Auth0 client id
 * @returns URLSearchParams
 */ parcelHelpers.export(exports, "getConfig", ()=>getConfig);
/**
 * Get the access token of a logged in user. Useful when you need to send this token to a backend service from the client.
 *
 * @param clientId Auth0 client id
 * @returns Access token or null
 */ parcelHelpers.export(exports, "getAccessToken", ()=>getAccessToken);
/**
 * Returns the access token fully parsed and decoded of a loggedin user.
 *
 * @param clientId Auth0 client id
 * @returns The parsed access token or null
 */ parcelHelpers.export(exports, "getUserSubscriptions", ()=>getUserSubscriptions);
/**
 * Returns the access token fully parsed and decoded of a loggedin user.
 *
 * @param clientId Auth0 client id
 * @returns The parsed access token or null
 */ parcelHelpers.export(exports, "getDecodedAccessToken", ()=>getDecodedAccessToken);
/**
 * Retrieve the raw id token of a logged in user. If you're looking to extract this infomration you can simply use the `getUserInfo` function instead.
 *
 * @param clientId Auth0 client id
 * @returns Raw JWT id token or null
 */ parcelHelpers.export(exports, "getIdToken", ()=>getIdToken);
/**
 * Returns the id token fully parsed and decoded of a loggedin user.
 *
 * @param clientId Auth0 client id
 * @returns The parsed id token or null
 */ parcelHelpers.export(exports, "getUserInfo", ()=>getUserInfo);
/**
 * Is the user authenticated?
 *
 * @param clientId Auth0 client id
 * @returns True if the user is authenticated, false otherwise
 */ parcelHelpers.export(exports, "isAuthenticated", ()=>isAuthenticated);
/**
 * Is the email verified?
 *
 * @param clientId Auth0 client id
 * @returns True if the email is verified, false otherwise
 */ parcelHelpers.export(exports, "isEmailVerified", ()=>isEmailVerified);
parcelHelpers.export(exports, "sendEmailVerification", ()=>sendEmailVerification);
/**
 * Some brands require to show an email confirmation before reading any metered or plus articles.
 * showEmailConfirmation let you put our shared component based on the Mediahuis design system in your page.
 *
 * @param options The list of options to pass to the popup
 * @param options.clientId Auth0 client id
 * @param options.type The type of email confirmation to show
 * @param options.el The DOM element to render the email confirmation in
 * @returns
 */ parcelHelpers.export(exports, "showEmailConfirmation", ()=>showEmailConfirmation);
/**
 * If you want to control when to show the silent login popup.
 *
 * Note that we're using the Mediahuis design system to create these popups.
 *
 * @param options The list of options to pass to the popup
 * @param options.clientId Auth0 client id
 * @param options.brand The full name of the brand (e.g. "De Standaard")
 * @returns
 */ parcelHelpers.export(exports, "showSilentLoginNotification", ()=>showSilentLoginNotification);
var _cookie = require("./modules/cookie");
function getConfig(clientId) {
    return new URLSearchParams((0, _cookie.getCookie)(`auth0_${clientId}_config`));
}
function getAccessToken(clientId) {
    return (0, _cookie.getCookie)(`auth0_${clientId}_acc_token`);
}
async function getUserSubscriptions(clientId) {
    const decodedAccessToken = await getDecodedAccessToken(clientId);
    return decodedAccessToken?.["https://mediahuis.com/subscribed-accesses"] ?? [];
}
async function getDecodedAccessToken(clientId) {
    return (0, _cookie.extractToken)(`auth0_${clientId}_acc_token`);
}
function getIdToken(clientId) {
    return (0, _cookie.getCookie)(`auth0_${clientId}_id_token`);
}
async function getUserInfo(clientId) {
    return (0, _cookie.extractToken)(`auth0_${clientId}_id_token`);
}
function isAuthenticated(clientId) {
    return !!getAccessToken(clientId) && !!getIdToken(clientId);
}
async function isEmailVerified(clientId) {
    const userInfo = await getUserInfo(clientId);
    if (!userInfo) return false;
    return userInfo.email_verified;
}
async function sendEmailVerification(clientId) {
    const config = getConfig(clientId);
    const userInfo = await getUserInfo(clientId);
    if (userInfo.email_verified || !config.has("base") || !config.has("redirectUri")) return false;
    const searchParams = new URLSearchParams({
        client_id: clientId,
        response_type: "token",
        audience: "https://ciam-api.mediahuis.com",
        redirect_uri: `${window.location.origin}${config.get("redirectUri")}`,
        response_mode: "web_message",
        prompt: "none"
    });
    const url = new URL(`${config.get("issuer")}/authorize?${searchParams}`);
    const iframe = document.createElement("iframe");
    return new Promise((resolve)=>{
        window.addEventListener("message", async function onMessage(event) {
            if (event.data.type === "authorization_response") {
                window.removeEventListener("message", onMessage);
                document.body.removeChild(iframe);
                const verifyEmailRequestURL = new URL(`${window.location.origin}${config.get("base")}/verify-email-request`);
                verifyEmailRequestURL.searchParams.append("account", userInfo.sub);
                const token = event.data.response.access_token;
                const resp = await this.fetch(verifyEmailRequestURL, {
                    method: "POST",
                    credentials: "omit",
                    headers: {
                        authorization: "Bearer " + token
                    },
                    body: JSON.stringify({
                        clientId
                    })
                });
                resolve(resp.ok);
            }
        });
        iframe.src = url.toString();
        document.body.appendChild(iframe);
    });
}
async function showEmailConfirmation({ type, brand, clientId, el }) {
    const { appendEmailVerificationWall } = await require("66a47a449972960f");
    if (type !== "paywall") throw new Error(`Unsupported type: ${type}, only paywall is currently implemented.`);
    if (!isAuthenticated(clientId)) throw new Error(`User is not authenticated.`);
    const userInfo = await getUserInfo(clientId);
    if (userInfo.email_verified) throw new Error(`User has already been verified.`);
    return appendEmailVerificationWall(el, {
        email: userInfo.email,
        brand,
        clientId
    });
}
async function showSilentLoginNotification({ clientId, brand }) {
    if (!window?.location?.search?.includes("_sl=1")) return;
    const parsedUrl = new URL(window.location.href);
    parsedUrl.searchParams.delete("_sl");
    window.history.replaceState(history.state, undefined, parsedUrl.toString());
    const userInfo = await getUserInfo(clientId);
    if (!userInfo.email) return;
    const { appendNotificationToast } = await require("de87de1e0bec0e97");
    let root = document.getElementById("auth0_silent-login-root");
    if (!root) {
        root = document.createElement("div");
        root.id = "auth0_silent-login-root";
        root.className = "chameleon-theme-mh";
        Object.assign(root.style, {
            position: "absolute",
            top: 0,
            right: 0,
            zIndex: "9999"
        });
    }
    await appendNotificationToast(root, {
        email: userInfo.email,
        brand
    });
    return new Promise((resolve)=>{
        requestAnimationFrame(()=>{
            if (!document.getElementById("auth0_silent-login-root")) document.body.appendChild(root);
            resolve();
        });
    });
}

},{"./modules/cookie":"lK6AJ","66a47a449972960f":"jCXmG","de87de1e0bec0e97":"cUaV9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lK6AJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCookie", ()=>getCookie);
parcelHelpers.export(exports, "extractToken", ()=>extractToken);
var _jose = require("jose");
function getCookie(cookieName) {
    const cookies = document.cookie.split(";");
    for (const c of cookies){
        const [name, ...value] = c.split("=");
        if (name.trim() === cookieName) return value.join("=");
    }
    return null;
}
function extractToken(cookieName) {
    const cookie = getCookie(cookieName);
    if (!cookie) return null;
    return (0, _jose.decodeJwt)(cookie);
}

},{"jose":"6gglG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6gglG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "compactDecrypt", ()=>(0, _decryptJs.compactDecrypt));
parcelHelpers.export(exports, "flattenedDecrypt", ()=>(0, _decryptJs1.flattenedDecrypt));
parcelHelpers.export(exports, "generalDecrypt", ()=>(0, _decryptJs2.generalDecrypt));
parcelHelpers.export(exports, "GeneralEncrypt", ()=>(0, _encryptJs.GeneralEncrypt));
parcelHelpers.export(exports, "compactVerify", ()=>(0, _verifyJs.compactVerify));
parcelHelpers.export(exports, "flattenedVerify", ()=>(0, _verifyJs1.flattenedVerify));
parcelHelpers.export(exports, "generalVerify", ()=>(0, _verifyJs2.generalVerify));
parcelHelpers.export(exports, "jwtVerify", ()=>(0, _verifyJs3.jwtVerify));
parcelHelpers.export(exports, "jwtDecrypt", ()=>(0, _decryptJs3.jwtDecrypt));
parcelHelpers.export(exports, "CompactEncrypt", ()=>(0, _encryptJs1.CompactEncrypt));
parcelHelpers.export(exports, "FlattenedEncrypt", ()=>(0, _encryptJs2.FlattenedEncrypt));
parcelHelpers.export(exports, "CompactSign", ()=>(0, _signJs.CompactSign));
parcelHelpers.export(exports, "FlattenedSign", ()=>(0, _signJs1.FlattenedSign));
parcelHelpers.export(exports, "GeneralSign", ()=>(0, _signJs2.GeneralSign));
parcelHelpers.export(exports, "SignJWT", ()=>(0, _signJs3.SignJWT));
parcelHelpers.export(exports, "EncryptJWT", ()=>(0, _encryptJs3.EncryptJWT));
parcelHelpers.export(exports, "calculateJwkThumbprint", ()=>(0, _thumbprintJs.calculateJwkThumbprint));
parcelHelpers.export(exports, "calculateJwkThumbprintUri", ()=>(0, _thumbprintJs.calculateJwkThumbprintUri));
parcelHelpers.export(exports, "EmbeddedJWK", ()=>(0, _embeddedJs.EmbeddedJWK));
parcelHelpers.export(exports, "createLocalJWKSet", ()=>(0, _localJs.createLocalJWKSet));
parcelHelpers.export(exports, "createRemoteJWKSet", ()=>(0, _remoteJs.createRemoteJWKSet));
parcelHelpers.export(exports, "UnsecuredJWT", ()=>(0, _unsecuredJs.UnsecuredJWT));
parcelHelpers.export(exports, "exportPKCS8", ()=>(0, _exportJs.exportPKCS8));
parcelHelpers.export(exports, "exportSPKI", ()=>(0, _exportJs.exportSPKI));
parcelHelpers.export(exports, "exportJWK", ()=>(0, _exportJs.exportJWK));
parcelHelpers.export(exports, "importSPKI", ()=>(0, _importJs.importSPKI));
parcelHelpers.export(exports, "importPKCS8", ()=>(0, _importJs.importPKCS8));
parcelHelpers.export(exports, "importX509", ()=>(0, _importJs.importX509));
parcelHelpers.export(exports, "importJWK", ()=>(0, _importJs.importJWK));
parcelHelpers.export(exports, "decodeProtectedHeader", ()=>(0, _decodeProtectedHeaderJs.decodeProtectedHeader));
parcelHelpers.export(exports, "decodeJwt", ()=>(0, _decodeJwtJs.decodeJwt));
parcelHelpers.export(exports, "generateKeyPair", ()=>(0, _generateKeyPairJs.generateKeyPair));
parcelHelpers.export(exports, "generateSecret", ()=>(0, _generateSecretJs.generateSecret));
parcelHelpers.export(exports, "cryptoRuntime", ()=>(0, _runtimeJsDefault.default));
parcelHelpers.export(exports, "errors", ()=>_errorsJs);
parcelHelpers.export(exports, "base64url", ()=>_base64UrlJs);
var _decryptJs = require("./jwe/compact/decrypt.js");
var _decryptJs1 = require("./jwe/flattened/decrypt.js");
var _decryptJs2 = require("./jwe/general/decrypt.js");
var _encryptJs = require("./jwe/general/encrypt.js");
var _verifyJs = require("./jws/compact/verify.js");
var _verifyJs1 = require("./jws/flattened/verify.js");
var _verifyJs2 = require("./jws/general/verify.js");
var _verifyJs3 = require("./jwt/verify.js");
var _decryptJs3 = require("./jwt/decrypt.js");
var _encryptJs1 = require("./jwe/compact/encrypt.js");
var _encryptJs2 = require("./jwe/flattened/encrypt.js");
var _signJs = require("./jws/compact/sign.js");
var _signJs1 = require("./jws/flattened/sign.js");
var _signJs2 = require("./jws/general/sign.js");
var _signJs3 = require("./jwt/sign.js");
var _encryptJs3 = require("./jwt/encrypt.js");
var _thumbprintJs = require("./jwk/thumbprint.js");
var _embeddedJs = require("./jwk/embedded.js");
var _localJs = require("./jwks/local.js");
var _remoteJs = require("./jwks/remote.js");
var _unsecuredJs = require("./jwt/unsecured.js");
var _exportJs = require("./key/export.js");
var _importJs = require("./key/import.js");
var _decodeProtectedHeaderJs = require("./util/decode_protected_header.js");
var _decodeJwtJs = require("./util/decode_jwt.js");
var _errorsJs = require("./util/errors.js");
var _generateKeyPairJs = require("./key/generate_key_pair.js");
var _generateSecretJs = require("./key/generate_secret.js");
var _base64UrlJs = require("./util/base64url.js");
var _runtimeJs = require("./util/runtime.js");
var _runtimeJsDefault = parcelHelpers.interopDefault(_runtimeJs);

},{"./jwe/compact/decrypt.js":"e85ol","./jwe/flattened/decrypt.js":"5HUvj","./jwe/general/decrypt.js":"av2Hr","./jwe/general/encrypt.js":"bS3zk","./jws/compact/verify.js":"dFemI","./jws/flattened/verify.js":"2EX3K","./jws/general/verify.js":"f4rEE","./jwt/verify.js":"9uAkr","./jwt/decrypt.js":"lrzVM","./jwe/compact/encrypt.js":"2Mv4N","./jwe/flattened/encrypt.js":"gNmwl","./jws/compact/sign.js":"4n4CU","./jws/flattened/sign.js":"lqvdz","./jws/general/sign.js":"chvqI","./jwt/sign.js":"ix6nL","./jwt/encrypt.js":"0M0j5","./jwk/thumbprint.js":"dM89g","./jwk/embedded.js":"kUHEj","./jwks/local.js":"gZQHZ","./jwks/remote.js":"gn9Cj","./jwt/unsecured.js":"8DlpU","./key/export.js":"1EYA6","./key/import.js":"661YL","./util/decode_protected_header.js":"kBsUQ","./util/decode_jwt.js":"aGTXa","./util/errors.js":"4fsOp","./key/generate_key_pair.js":"h6CYR","./key/generate_secret.js":"jmQID","./util/base64url.js":"bljA2","./util/runtime.js":"l9K66","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e85ol":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "compactDecrypt", ()=>compactDecrypt);
var _decryptJs = require("../flattened/decrypt.js");
var _errorsJs = require("../../util/errors.js");
var _bufferUtilsJs = require("../../lib/buffer_utils.js");
async function compactDecrypt(jwe, key, options) {
    if (jwe instanceof Uint8Array) jwe = (0, _bufferUtilsJs.decoder).decode(jwe);
    if (typeof jwe !== "string") throw new (0, _errorsJs.JWEInvalid)("Compact JWE must be a string or Uint8Array");
    const { 0: protectedHeader, 1: encryptedKey, 2: iv, 3: ciphertext, 4: tag, length } = jwe.split(".");
    if (length !== 5) throw new (0, _errorsJs.JWEInvalid)("Invalid Compact JWE");
    const decrypted = await (0, _decryptJs.flattenedDecrypt)({
        ciphertext,
        iv: iv || undefined,
        protected: protectedHeader || undefined,
        tag: tag || undefined,
        encrypted_key: encryptedKey || undefined
    }, key, options);
    const result = {
        plaintext: decrypted.plaintext,
        protectedHeader: decrypted.protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: decrypted.key
    };
    return result;
}

},{"../flattened/decrypt.js":"5HUvj","../../util/errors.js":"4fsOp","../../lib/buffer_utils.js":"h0x9u","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5HUvj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "flattenedDecrypt", ()=>flattenedDecrypt);
var _base64UrlJs = require("../../runtime/base64url.js");
var _decryptJs = require("../../runtime/decrypt.js");
var _decryptJsDefault = parcelHelpers.interopDefault(_decryptJs);
var _zlibJs = require("../../runtime/zlib.js");
var _errorsJs = require("../../util/errors.js");
var _isDisjointJs = require("../../lib/is_disjoint.js");
var _isDisjointJsDefault = parcelHelpers.interopDefault(_isDisjointJs);
var _isObjectJs = require("../../lib/is_object.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _decryptKeyManagementJs = require("../../lib/decrypt_key_management.js");
var _decryptKeyManagementJsDefault = parcelHelpers.interopDefault(_decryptKeyManagementJs);
var _bufferUtilsJs = require("../../lib/buffer_utils.js");
var _cekJs = require("../../lib/cek.js");
var _cekJsDefault = parcelHelpers.interopDefault(_cekJs);
var _validateCritJs = require("../../lib/validate_crit.js");
var _validateCritJsDefault = parcelHelpers.interopDefault(_validateCritJs);
var _validateAlgorithmsJs = require("../../lib/validate_algorithms.js");
var _validateAlgorithmsJsDefault = parcelHelpers.interopDefault(_validateAlgorithmsJs);
async function flattenedDecrypt(jwe, key, options) {
    var _a;
    if (!(0, _isObjectJsDefault.default)(jwe)) throw new (0, _errorsJs.JWEInvalid)("Flattened JWE must be an object");
    if (jwe.protected === undefined && jwe.header === undefined && jwe.unprotected === undefined) throw new (0, _errorsJs.JWEInvalid)("JOSE Header missing");
    if (typeof jwe.iv !== "string") throw new (0, _errorsJs.JWEInvalid)("JWE Initialization Vector missing or incorrect type");
    if (typeof jwe.ciphertext !== "string") throw new (0, _errorsJs.JWEInvalid)("JWE Ciphertext missing or incorrect type");
    if (typeof jwe.tag !== "string") throw new (0, _errorsJs.JWEInvalid)("JWE Authentication Tag missing or incorrect type");
    if (jwe.protected !== undefined && typeof jwe.protected !== "string") throw new (0, _errorsJs.JWEInvalid)("JWE Protected Header incorrect type");
    if (jwe.encrypted_key !== undefined && typeof jwe.encrypted_key !== "string") throw new (0, _errorsJs.JWEInvalid)("JWE Encrypted Key incorrect type");
    if (jwe.aad !== undefined && typeof jwe.aad !== "string") throw new (0, _errorsJs.JWEInvalid)("JWE AAD incorrect type");
    if (jwe.header !== undefined && !(0, _isObjectJsDefault.default)(jwe.header)) throw new (0, _errorsJs.JWEInvalid)("JWE Shared Unprotected Header incorrect type");
    if (jwe.unprotected !== undefined && !(0, _isObjectJsDefault.default)(jwe.unprotected)) throw new (0, _errorsJs.JWEInvalid)("JWE Per-Recipient Unprotected Header incorrect type");
    let parsedProt;
    if (jwe.protected) try {
        const protectedHeader = (0, _base64UrlJs.decode)(jwe.protected);
        parsedProt = JSON.parse((0, _bufferUtilsJs.decoder).decode(protectedHeader));
    } catch (_b) {
        throw new (0, _errorsJs.JWEInvalid)("JWE Protected Header is invalid");
    }
    if (!(0, _isDisjointJsDefault.default)(parsedProt, jwe.header, jwe.unprotected)) throw new (0, _errorsJs.JWEInvalid)("JWE Protected, JWE Unprotected Header, and JWE Per-Recipient Unprotected Header Parameter names must be disjoint");
    const joseHeader = {
        ...parsedProt,
        ...jwe.header,
        ...jwe.unprotected
    };
    (0, _validateCritJsDefault.default)((0, _errorsJs.JWEInvalid), new Map(), options === null || options === void 0 ? void 0 : options.crit, parsedProt, joseHeader);
    if (joseHeader.zip !== undefined) {
        if (!parsedProt || !parsedProt.zip) throw new (0, _errorsJs.JWEInvalid)('JWE "zip" (Compression Algorithm) Header MUST be integrity protected');
        if (joseHeader.zip !== "DEF") throw new (0, _errorsJs.JOSENotSupported)('Unsupported JWE "zip" (Compression Algorithm) Header Parameter value');
    }
    const { alg, enc } = joseHeader;
    if (typeof alg !== "string" || !alg) throw new (0, _errorsJs.JWEInvalid)("missing JWE Algorithm (alg) in JWE Header");
    if (typeof enc !== "string" || !enc) throw new (0, _errorsJs.JWEInvalid)("missing JWE Encryption Algorithm (enc) in JWE Header");
    const keyManagementAlgorithms = options && (0, _validateAlgorithmsJsDefault.default)("keyManagementAlgorithms", options.keyManagementAlgorithms);
    const contentEncryptionAlgorithms = options && (0, _validateAlgorithmsJsDefault.default)("contentEncryptionAlgorithms", options.contentEncryptionAlgorithms);
    if (keyManagementAlgorithms && !keyManagementAlgorithms.has(alg)) throw new (0, _errorsJs.JOSEAlgNotAllowed)('"alg" (Algorithm) Header Parameter not allowed');
    if (contentEncryptionAlgorithms && !contentEncryptionAlgorithms.has(enc)) throw new (0, _errorsJs.JOSEAlgNotAllowed)('"enc" (Encryption Algorithm) Header Parameter not allowed');
    let encryptedKey;
    if (jwe.encrypted_key !== undefined) try {
        encryptedKey = (0, _base64UrlJs.decode)(jwe.encrypted_key);
    } catch (_c) {
        throw new (0, _errorsJs.JWEInvalid)("Failed to base64url decode the encrypted_key");
    }
    let resolvedKey = false;
    if (typeof key === "function") {
        key = await key(parsedProt, jwe);
        resolvedKey = true;
    }
    let cek;
    try {
        cek = await (0, _decryptKeyManagementJsDefault.default)(alg, key, encryptedKey, joseHeader, options);
    } catch (err) {
        if (err instanceof TypeError || err instanceof (0, _errorsJs.JWEInvalid) || err instanceof (0, _errorsJs.JOSENotSupported)) throw err;
        cek = (0, _cekJsDefault.default)(enc);
    }
    let iv;
    let tag;
    try {
        iv = (0, _base64UrlJs.decode)(jwe.iv);
    } catch (_d) {
        throw new (0, _errorsJs.JWEInvalid)("Failed to base64url decode the iv");
    }
    try {
        tag = (0, _base64UrlJs.decode)(jwe.tag);
    } catch (_e) {
        throw new (0, _errorsJs.JWEInvalid)("Failed to base64url decode the tag");
    }
    const protectedHeader = (0, _bufferUtilsJs.encoder).encode((_a = jwe.protected) !== null && _a !== void 0 ? _a : "");
    let additionalData;
    if (jwe.aad !== undefined) additionalData = (0, _bufferUtilsJs.concat)(protectedHeader, (0, _bufferUtilsJs.encoder).encode("."), (0, _bufferUtilsJs.encoder).encode(jwe.aad));
    else additionalData = protectedHeader;
    let ciphertext;
    try {
        ciphertext = (0, _base64UrlJs.decode)(jwe.ciphertext);
    } catch (_f) {
        throw new (0, _errorsJs.JWEInvalid)("Failed to base64url decode the ciphertext");
    }
    let plaintext = await (0, _decryptJsDefault.default)(enc, cek, ciphertext, iv, tag, additionalData);
    if (joseHeader.zip === "DEF") plaintext = await ((options === null || options === void 0 ? void 0 : options.inflateRaw) || (0, _zlibJs.inflate))(plaintext);
    const result = {
        plaintext
    };
    if (jwe.protected !== undefined) result.protectedHeader = parsedProt;
    if (jwe.aad !== undefined) try {
        result.additionalAuthenticatedData = (0, _base64UrlJs.decode)(jwe.aad);
    } catch (_g) {
        throw new (0, _errorsJs.JWEInvalid)("Failed to base64url decode the aad");
    }
    if (jwe.unprotected !== undefined) result.sharedUnprotectedHeader = jwe.unprotected;
    if (jwe.header !== undefined) result.unprotectedHeader = jwe.header;
    if (resolvedKey) return {
        ...result,
        key
    };
    return result;
}

},{"../../runtime/base64url.js":"8Djx4","../../runtime/decrypt.js":"dPMLp","../../runtime/zlib.js":"dM1d1","../../util/errors.js":"4fsOp","../../lib/is_disjoint.js":"91YXn","../../lib/is_object.js":"daSnu","../../lib/decrypt_key_management.js":"bdNgc","../../lib/buffer_utils.js":"h0x9u","../../lib/cek.js":"cA5vi","../../lib/validate_crit.js":"1cFtE","../../lib/validate_algorithms.js":"fDDwK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Djx4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "encodeBase64", ()=>encodeBase64);
parcelHelpers.export(exports, "encode", ()=>encode);
parcelHelpers.export(exports, "decodeBase64", ()=>decodeBase64);
parcelHelpers.export(exports, "decode", ()=>decode);
var _bufferUtilsJs = require("../lib/buffer_utils.js");
const encodeBase64 = (input)=>{
    let unencoded = input;
    if (typeof unencoded === "string") unencoded = (0, _bufferUtilsJs.encoder).encode(unencoded);
    const CHUNK_SIZE = 0x8000;
    const arr = [];
    for(let i = 0; i < unencoded.length; i += CHUNK_SIZE)arr.push(String.fromCharCode.apply(null, unencoded.subarray(i, i + CHUNK_SIZE)));
    return btoa(arr.join(""));
};
const encode = (input)=>{
    return encodeBase64(input).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
};
const decodeBase64 = (encoded)=>{
    const binary = atob(encoded);
    const bytes = new Uint8Array(binary.length);
    for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
    return bytes;
};
const decode = (input)=>{
    let encoded = input;
    if (encoded instanceof Uint8Array) encoded = (0, _bufferUtilsJs.decoder).decode(encoded);
    encoded = encoded.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "");
    try {
        return decodeBase64(encoded);
    } catch (_a) {
        throw new TypeError("The input to be decoded is not correctly encoded.");
    }
};

},{"../lib/buffer_utils.js":"h0x9u","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h0x9u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "encoder", ()=>encoder);
parcelHelpers.export(exports, "decoder", ()=>decoder);
parcelHelpers.export(exports, "concat", ()=>concat);
parcelHelpers.export(exports, "p2s", ()=>p2s);
parcelHelpers.export(exports, "uint64be", ()=>uint64be);
parcelHelpers.export(exports, "uint32be", ()=>uint32be);
parcelHelpers.export(exports, "lengthAndInput", ()=>lengthAndInput);
parcelHelpers.export(exports, "concatKdf", ()=>concatKdf);
var _digestJs = require("../runtime/digest.js");
var _digestJsDefault = parcelHelpers.interopDefault(_digestJs);
const encoder = new TextEncoder();
const decoder = new TextDecoder();
const MAX_INT32 = 2 ** 32;
function concat(...buffers) {
    const size = buffers.reduce((acc, { length })=>acc + length, 0);
    const buf = new Uint8Array(size);
    let i = 0;
    buffers.forEach((buffer)=>{
        buf.set(buffer, i);
        i += buffer.length;
    });
    return buf;
}
function p2s(alg, p2sInput) {
    return concat(encoder.encode(alg), new Uint8Array([
        0
    ]), p2sInput);
}
function writeUInt32BE(buf, value, offset) {
    if (value < 0 || value >= MAX_INT32) throw new RangeError(`value must be >= 0 and <= ${MAX_INT32 - 1}. Received ${value}`);
    buf.set([
        value >>> 24,
        value >>> 16,
        value >>> 8,
        value & 0xff
    ], offset);
}
function uint64be(value) {
    const high = Math.floor(value / MAX_INT32);
    const low = value % MAX_INT32;
    const buf = new Uint8Array(8);
    writeUInt32BE(buf, high, 0);
    writeUInt32BE(buf, low, 4);
    return buf;
}
function uint32be(value) {
    const buf = new Uint8Array(4);
    writeUInt32BE(buf, value);
    return buf;
}
function lengthAndInput(input) {
    return concat(uint32be(input.length), input);
}
async function concatKdf(secret, bits, value) {
    const iterations = Math.ceil((bits >> 3) / 32);
    const res = new Uint8Array(iterations * 32);
    for(let iter = 0; iter < iterations; iter++){
        const buf = new Uint8Array(4 + secret.length + value.length);
        buf.set(uint32be(iter + 1));
        buf.set(secret, 4);
        buf.set(value, 4 + secret.length);
        res.set(await (0, _digestJsDefault.default)("sha256", buf), iter * 32);
    }
    return res.slice(0, bits >> 3);
}

},{"../runtime/digest.js":"hdTL7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hdTL7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _webcryptoJs = require("./webcrypto.js");
var _webcryptoJsDefault = parcelHelpers.interopDefault(_webcryptoJs);
const digest = async (algorithm, data)=>{
    const subtleDigest = `SHA-${algorithm.slice(-3)}`;
    return new Uint8Array(await (0, _webcryptoJsDefault.default).subtle.digest(subtleDigest, data));
};
exports.default = digest;

},{"./webcrypto.js":"aUHBb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aUHBb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isCryptoKey", ()=>isCryptoKey);
exports.default = crypto;
const isCryptoKey = (key)=>key instanceof CryptoKey;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k3151":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"dPMLp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _bufferUtilsJs = require("../lib/buffer_utils.js");
var _checkIvLengthJs = require("../lib/check_iv_length.js");
var _checkIvLengthJsDefault = parcelHelpers.interopDefault(_checkIvLengthJs);
var _checkCekLengthJs = require("./check_cek_length.js");
var _checkCekLengthJsDefault = parcelHelpers.interopDefault(_checkCekLengthJs);
var _timingSafeEqualJs = require("./timing_safe_equal.js");
var _timingSafeEqualJsDefault = parcelHelpers.interopDefault(_timingSafeEqualJs);
var _errorsJs = require("../util/errors.js");
var _webcryptoJs = require("./webcrypto.js");
var _webcryptoJsDefault = parcelHelpers.interopDefault(_webcryptoJs);
var _cryptoKeyJs = require("../lib/crypto_key.js");
var _invalidKeyInputJs = require("../lib/invalid_key_input.js");
var _invalidKeyInputJsDefault = parcelHelpers.interopDefault(_invalidKeyInputJs);
var _isKeyLikeJs = require("./is_key_like.js");
async function cbcDecrypt(enc, cek, ciphertext, iv, tag, aad) {
    if (!(cek instanceof Uint8Array)) throw new TypeError((0, _invalidKeyInputJsDefault.default)(cek, "Uint8Array"));
    const keySize = parseInt(enc.slice(1, 4), 10);
    const encKey = await (0, _webcryptoJsDefault.default).subtle.importKey("raw", cek.subarray(keySize >> 3), "AES-CBC", false, [
        "decrypt"
    ]);
    const macKey = await (0, _webcryptoJsDefault.default).subtle.importKey("raw", cek.subarray(0, keySize >> 3), {
        hash: `SHA-${keySize << 1}`,
        name: "HMAC"
    }, false, [
        "sign"
    ]);
    const macData = (0, _bufferUtilsJs.concat)(aad, iv, ciphertext, (0, _bufferUtilsJs.uint64be)(aad.length << 3));
    const expectedTag = new Uint8Array((await (0, _webcryptoJsDefault.default).subtle.sign("HMAC", macKey, macData)).slice(0, keySize >> 3));
    let macCheckPassed;
    try {
        macCheckPassed = (0, _timingSafeEqualJsDefault.default)(tag, expectedTag);
    } catch (_a) {}
    if (!macCheckPassed) throw new (0, _errorsJs.JWEDecryptionFailed)();
    let plaintext;
    try {
        plaintext = new Uint8Array(await (0, _webcryptoJsDefault.default).subtle.decrypt({
            iv,
            name: "AES-CBC"
        }, encKey, ciphertext));
    } catch (_b) {}
    if (!plaintext) throw new (0, _errorsJs.JWEDecryptionFailed)();
    return plaintext;
}
async function gcmDecrypt(enc, cek, ciphertext, iv, tag, aad) {
    let encKey;
    if (cek instanceof Uint8Array) encKey = await (0, _webcryptoJsDefault.default).subtle.importKey("raw", cek, "AES-GCM", false, [
        "decrypt"
    ]);
    else {
        (0, _cryptoKeyJs.checkEncCryptoKey)(cek, enc, "decrypt");
        encKey = cek;
    }
    try {
        return new Uint8Array(await (0, _webcryptoJsDefault.default).subtle.decrypt({
            additionalData: aad,
            iv,
            name: "AES-GCM",
            tagLength: 128
        }, encKey, (0, _bufferUtilsJs.concat)(ciphertext, tag)));
    } catch (_a) {
        throw new (0, _errorsJs.JWEDecryptionFailed)();
    }
}
const decrypt = async (enc, cek, ciphertext, iv, tag, aad)=>{
    if (!(0, _webcryptoJs.isCryptoKey)(cek) && !(cek instanceof Uint8Array)) throw new TypeError((0, _invalidKeyInputJsDefault.default)(cek, ...(0, _isKeyLikeJs.types), "Uint8Array"));
    (0, _checkIvLengthJsDefault.default)(enc, iv);
    switch(enc){
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            if (cek instanceof Uint8Array) (0, _checkCekLengthJsDefault.default)(cek, parseInt(enc.slice(-3), 10));
            return cbcDecrypt(enc, cek, ciphertext, iv, tag, aad);
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            if (cek instanceof Uint8Array) (0, _checkCekLengthJsDefault.default)(cek, parseInt(enc.slice(1, 4), 10));
            return gcmDecrypt(enc, cek, ciphertext, iv, tag, aad);
        default:
            throw new (0, _errorsJs.JOSENotSupported)("Unsupported JWE Content Encryption Algorithm");
    }
};
exports.default = decrypt;

},{"../lib/buffer_utils.js":"h0x9u","../lib/check_iv_length.js":"7za2M","./check_cek_length.js":"9VrK5","./timing_safe_equal.js":"k4wY7","../util/errors.js":"4fsOp","./webcrypto.js":"aUHBb","../lib/crypto_key.js":"gM0cz","../lib/invalid_key_input.js":"5GTGb","./is_key_like.js":"9kDjz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7za2M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _errorsJs = require("../util/errors.js");
var _ivJs = require("./iv.js");
const checkIvLength = (enc, iv)=>{
    if (iv.length << 3 !== (0, _ivJs.bitLength)(enc)) throw new (0, _errorsJs.JWEInvalid)("Invalid Initialization Vector length");
};
exports.default = checkIvLength;

},{"../util/errors.js":"4fsOp","./iv.js":"bvMJc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4fsOp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JOSEError", ()=>JOSEError);
parcelHelpers.export(exports, "JWTClaimValidationFailed", ()=>JWTClaimValidationFailed);
parcelHelpers.export(exports, "JWTExpired", ()=>JWTExpired);
parcelHelpers.export(exports, "JOSEAlgNotAllowed", ()=>JOSEAlgNotAllowed);
parcelHelpers.export(exports, "JOSENotSupported", ()=>JOSENotSupported);
parcelHelpers.export(exports, "JWEDecryptionFailed", ()=>JWEDecryptionFailed);
parcelHelpers.export(exports, "JWEInvalid", ()=>JWEInvalid);
parcelHelpers.export(exports, "JWSInvalid", ()=>JWSInvalid);
parcelHelpers.export(exports, "JWTInvalid", ()=>JWTInvalid);
parcelHelpers.export(exports, "JWKInvalid", ()=>JWKInvalid);
parcelHelpers.export(exports, "JWKSInvalid", ()=>JWKSInvalid);
parcelHelpers.export(exports, "JWKSNoMatchingKey", ()=>JWKSNoMatchingKey);
parcelHelpers.export(exports, "JWKSMultipleMatchingKeys", ()=>JWKSMultipleMatchingKeys);
parcelHelpers.export(exports, "JWKSTimeout", ()=>JWKSTimeout);
parcelHelpers.export(exports, "JWSSignatureVerificationFailed", ()=>JWSSignatureVerificationFailed);
class JOSEError extends Error {
    static get code() {
        return "ERR_JOSE_GENERIC";
    }
    constructor(message){
        var _a;
        super(message);
        this.code = "ERR_JOSE_GENERIC";
        this.name = this.constructor.name;
        (_a = Error.captureStackTrace) === null || _a === void 0 || _a.call(Error, this, this.constructor);
    }
}
class JWTClaimValidationFailed extends JOSEError {
    static get code() {
        return "ERR_JWT_CLAIM_VALIDATION_FAILED";
    }
    constructor(message, claim = "unspecified", reason = "unspecified"){
        super(message);
        this.code = "ERR_JWT_CLAIM_VALIDATION_FAILED";
        this.claim = claim;
        this.reason = reason;
    }
}
class JWTExpired extends JOSEError {
    static get code() {
        return "ERR_JWT_EXPIRED";
    }
    constructor(message, claim = "unspecified", reason = "unspecified"){
        super(message);
        this.code = "ERR_JWT_EXPIRED";
        this.claim = claim;
        this.reason = reason;
    }
}
class JOSEAlgNotAllowed extends JOSEError {
    constructor(){
        super(...arguments);
        this.code = "ERR_JOSE_ALG_NOT_ALLOWED";
    }
    static get code() {
        return "ERR_JOSE_ALG_NOT_ALLOWED";
    }
}
class JOSENotSupported extends JOSEError {
    constructor(){
        super(...arguments);
        this.code = "ERR_JOSE_NOT_SUPPORTED";
    }
    static get code() {
        return "ERR_JOSE_NOT_SUPPORTED";
    }
}
class JWEDecryptionFailed extends JOSEError {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWE_DECRYPTION_FAILED";
        this.message = "decryption operation failed";
    }
    static get code() {
        return "ERR_JWE_DECRYPTION_FAILED";
    }
}
class JWEInvalid extends JOSEError {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWE_INVALID";
    }
    static get code() {
        return "ERR_JWE_INVALID";
    }
}
class JWSInvalid extends JOSEError {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWS_INVALID";
    }
    static get code() {
        return "ERR_JWS_INVALID";
    }
}
class JWTInvalid extends JOSEError {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWT_INVALID";
    }
    static get code() {
        return "ERR_JWT_INVALID";
    }
}
class JWKInvalid extends JOSEError {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWK_INVALID";
    }
    static get code() {
        return "ERR_JWK_INVALID";
    }
}
class JWKSInvalid extends JOSEError {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_INVALID";
    }
    static get code() {
        return "ERR_JWKS_INVALID";
    }
}
class JWKSNoMatchingKey extends JOSEError {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_NO_MATCHING_KEY";
        this.message = "no applicable key found in the JSON Web Key Set";
    }
    static get code() {
        return "ERR_JWKS_NO_MATCHING_KEY";
    }
}
class JWKSMultipleMatchingKeys extends JOSEError {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_MULTIPLE_MATCHING_KEYS";
        this.message = "multiple matching keys found in the JSON Web Key Set";
    }
    static get code() {
        return "ERR_JWKS_MULTIPLE_MATCHING_KEYS";
    }
}
Symbol.asyncIterator;
class JWKSTimeout extends JOSEError {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_TIMEOUT";
        this.message = "request timed out";
    }
    static get code() {
        return "ERR_JWKS_TIMEOUT";
    }
}
class JWSSignatureVerificationFailed extends JOSEError {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWS_SIGNATURE_VERIFICATION_FAILED";
        this.message = "signature verification failed";
    }
    static get code() {
        return "ERR_JWS_SIGNATURE_VERIFICATION_FAILED";
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bvMJc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bitLength", ()=>bitLength);
var _errorsJs = require("../util/errors.js");
var _randomJs = require("../runtime/random.js");
var _randomJsDefault = parcelHelpers.interopDefault(_randomJs);
function bitLength(alg) {
    switch(alg){
        case "A128GCM":
        case "A128GCMKW":
        case "A192GCM":
        case "A192GCMKW":
        case "A256GCM":
        case "A256GCMKW":
            return 96;
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            return 128;
        default:
            throw new (0, _errorsJs.JOSENotSupported)(`Unsupported JWE Algorithm: ${alg}`);
    }
}
exports.default = (alg)=>(0, _randomJsDefault.default)(new Uint8Array(bitLength(alg) >> 3));

},{"../util/errors.js":"4fsOp","../runtime/random.js":"4nPoE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4nPoE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _webcryptoJs = require("./webcrypto.js");
var _webcryptoJsDefault = parcelHelpers.interopDefault(_webcryptoJs);
exports.default = (0, _webcryptoJsDefault.default).getRandomValues.bind((0, _webcryptoJsDefault.default));

},{"./webcrypto.js":"aUHBb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9VrK5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _errorsJs = require("../util/errors.js");
const checkCekLength = (cek, expected)=>{
    const actual = cek.byteLength << 3;
    if (actual !== expected) throw new (0, _errorsJs.JWEInvalid)(`Invalid Content Encryption Key length. Expected ${expected} bits, got ${actual} bits`);
};
exports.default = checkCekLength;

},{"../util/errors.js":"4fsOp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k4wY7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const timingSafeEqual = (a, b)=>{
    if (!(a instanceof Uint8Array)) throw new TypeError("First argument must be a buffer");
    if (!(b instanceof Uint8Array)) throw new TypeError("Second argument must be a buffer");
    if (a.length !== b.length) throw new TypeError("Input buffers must have the same length");
    const len = a.length;
    let out = 0;
    let i = -1;
    while(++i < len)out |= a[i] ^ b[i];
    return out === 0;
};
exports.default = timingSafeEqual;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gM0cz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "checkSigCryptoKey", ()=>checkSigCryptoKey);
parcelHelpers.export(exports, "checkEncCryptoKey", ()=>checkEncCryptoKey);
function unusable(name, prop = "algorithm.name") {
    return new TypeError(`CryptoKey does not support this operation, its ${prop} must be ${name}`);
}
function isAlgorithm(algorithm, name) {
    return algorithm.name === name;
}
function getHashLength(hash) {
    return parseInt(hash.name.slice(4), 10);
}
function getNamedCurve(alg) {
    switch(alg){
        case "ES256":
            return "P-256";
        case "ES384":
            return "P-384";
        case "ES512":
            return "P-521";
        default:
            throw new Error("unreachable");
    }
}
function checkUsage(key, usages) {
    if (usages.length && !usages.some((expected)=>key.usages.includes(expected))) {
        let msg = "CryptoKey does not support this operation, its usages must include ";
        if (usages.length > 2) {
            const last = usages.pop();
            msg += `one of ${usages.join(", ")}, or ${last}.`;
        } else if (usages.length === 2) msg += `one of ${usages[0]} or ${usages[1]}.`;
        else msg += `${usages[0]}.`;
        throw new TypeError(msg);
    }
}
function checkSigCryptoKey(key, alg, ...usages) {
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            {
                if (!isAlgorithm(key.algorithm, "HMAC")) throw unusable("HMAC");
                const expected = parseInt(alg.slice(2), 10);
                const actual = getHashLength(key.algorithm.hash);
                if (actual !== expected) throw unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "RS256":
        case "RS384":
        case "RS512":
            {
                if (!isAlgorithm(key.algorithm, "RSASSA-PKCS1-v1_5")) throw unusable("RSASSA-PKCS1-v1_5");
                const expected = parseInt(alg.slice(2), 10);
                const actual = getHashLength(key.algorithm.hash);
                if (actual !== expected) throw unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "PS256":
        case "PS384":
        case "PS512":
            {
                if (!isAlgorithm(key.algorithm, "RSA-PSS")) throw unusable("RSA-PSS");
                const expected = parseInt(alg.slice(2), 10);
                const actual = getHashLength(key.algorithm.hash);
                if (actual !== expected) throw unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "EdDSA":
            if (key.algorithm.name !== "Ed25519" && key.algorithm.name !== "Ed448") throw unusable("Ed25519 or Ed448");
            break;
        case "ES256":
        case "ES384":
        case "ES512":
            {
                if (!isAlgorithm(key.algorithm, "ECDSA")) throw unusable("ECDSA");
                const expected = getNamedCurve(alg);
                const actual = key.algorithm.namedCurve;
                if (actual !== expected) throw unusable(expected, "algorithm.namedCurve");
                break;
            }
        default:
            throw new TypeError("CryptoKey does not support this operation");
    }
    checkUsage(key, usages);
}
function checkEncCryptoKey(key, alg, ...usages) {
    switch(alg){
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            {
                if (!isAlgorithm(key.algorithm, "AES-GCM")) throw unusable("AES-GCM");
                const expected = parseInt(alg.slice(1, 4), 10);
                const actual = key.algorithm.length;
                if (actual !== expected) throw unusable(expected, "algorithm.length");
                break;
            }
        case "A128KW":
        case "A192KW":
        case "A256KW":
            {
                if (!isAlgorithm(key.algorithm, "AES-KW")) throw unusable("AES-KW");
                const expected = parseInt(alg.slice(1, 4), 10);
                const actual = key.algorithm.length;
                if (actual !== expected) throw unusable(expected, "algorithm.length");
                break;
            }
        case "ECDH":
            switch(key.algorithm.name){
                case "ECDH":
                case "X25519":
                case "X448":
                    break;
                default:
                    throw unusable("ECDH, X25519, or X448");
            }
            break;
        case "PBES2-HS256+A128KW":
        case "PBES2-HS384+A192KW":
        case "PBES2-HS512+A256KW":
            if (!isAlgorithm(key.algorithm, "PBKDF2")) throw unusable("PBKDF2");
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            {
                if (!isAlgorithm(key.algorithm, "RSA-OAEP")) throw unusable("RSA-OAEP");
                const expected = parseInt(alg.slice(9), 10) || 1;
                const actual = getHashLength(key.algorithm.hash);
                if (actual !== expected) throw unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        default:
            throw new TypeError("CryptoKey does not support this operation");
    }
    checkUsage(key, usages);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5GTGb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withAlg", ()=>withAlg);
function message(msg, actual, ...types) {
    if (types.length > 2) {
        const last = types.pop();
        msg += `one of type ${types.join(", ")}, or ${last}.`;
    } else if (types.length === 2) msg += `one of type ${types[0]} or ${types[1]}.`;
    else msg += `of type ${types[0]}.`;
    if (actual == null) msg += ` Received ${actual}`;
    else if (typeof actual === "function" && actual.name) msg += ` Received function ${actual.name}`;
    else if (typeof actual === "object" && actual != null) {
        if (actual.constructor && actual.constructor.name) msg += ` Received an instance of ${actual.constructor.name}`;
    }
    return msg;
}
exports.default = (actual, ...types)=>{
    return message("Key must be ", actual, ...types);
};
function withAlg(alg, actual, ...types) {
    return message(`Key for the ${alg} algorithm must be `, actual, ...types);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9kDjz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "types", ()=>types);
var _webcryptoJs = require("./webcrypto.js");
exports.default = (key)=>{
    return (0, _webcryptoJs.isCryptoKey)(key);
};
const types = [
    "CryptoKey"
];

},{"./webcrypto.js":"aUHBb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dM1d1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inflate", ()=>inflate);
parcelHelpers.export(exports, "deflate", ()=>deflate);
var _errorsJs = require("../util/errors.js");
const inflate = async ()=>{
    throw new (0, _errorsJs.JOSENotSupported)('JWE "zip" (Compression Algorithm) Header Parameter is not supported by your javascript runtime. You need to use the `inflateRaw` decrypt option to provide Inflate Raw implementation.');
};
const deflate = async ()=>{
    throw new (0, _errorsJs.JOSENotSupported)('JWE "zip" (Compression Algorithm) Header Parameter is not supported by your javascript runtime. You need to use the `deflateRaw` encrypt option to provide Deflate Raw implementation.');
};

},{"../util/errors.js":"4fsOp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"91YXn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const isDisjoint = (...headers)=>{
    const sources = headers.filter(Boolean);
    if (sources.length === 0 || sources.length === 1) return true;
    let acc;
    for (const header of sources){
        const parameters = Object.keys(header);
        if (!acc || acc.size === 0) {
            acc = new Set(parameters);
            continue;
        }
        for (const parameter of parameters){
            if (acc.has(parameter)) return false;
            acc.add(parameter);
        }
    }
    return true;
};
exports.default = isDisjoint;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"daSnu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isObject);
function isObjectLike(value) {
    return typeof value === "object" && value !== null;
}
function isObject(input) {
    if (!isObjectLike(input) || Object.prototype.toString.call(input) !== "[object Object]") return false;
    if (Object.getPrototypeOf(input) === null) return true;
    let proto = input;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(input) === proto;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bdNgc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _aeskwJs = require("../runtime/aeskw.js");
var _ecdhesJs = require("../runtime/ecdhes.js");
var _pbes2KwJs = require("../runtime/pbes2kw.js");
var _rsaesJs = require("../runtime/rsaes.js");
var _base64UrlJs = require("../runtime/base64url.js");
var _errorsJs = require("../util/errors.js");
var _cekJs = require("../lib/cek.js");
var _importJs = require("../key/import.js");
var _checkKeyTypeJs = require("./check_key_type.js");
var _checkKeyTypeJsDefault = parcelHelpers.interopDefault(_checkKeyTypeJs);
var _isObjectJs = require("./is_object.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _aesgcmkwJs = require("./aesgcmkw.js");
async function decryptKeyManagement(alg, key, encryptedKey, joseHeader, options) {
    (0, _checkKeyTypeJsDefault.default)(alg, key, "decrypt");
    switch(alg){
        case "dir":
            if (encryptedKey !== undefined) throw new (0, _errorsJs.JWEInvalid)("Encountered unexpected JWE Encrypted Key");
            return key;
        case "ECDH-ES":
            if (encryptedKey !== undefined) throw new (0, _errorsJs.JWEInvalid)("Encountered unexpected JWE Encrypted Key");
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                if (!(0, _isObjectJsDefault.default)(joseHeader.epk)) throw new (0, _errorsJs.JWEInvalid)(`JOSE Header "epk" (Ephemeral Public Key) missing or invalid`);
                if (!_ecdhesJs.ecdhAllowed(key)) throw new (0, _errorsJs.JOSENotSupported)("ECDH with the provided key is not allowed or not supported by your javascript runtime");
                const epk = await (0, _importJs.importJWK)(joseHeader.epk, alg);
                let partyUInfo;
                let partyVInfo;
                if (joseHeader.apu !== undefined) {
                    if (typeof joseHeader.apu !== "string") throw new (0, _errorsJs.JWEInvalid)(`JOSE Header "apu" (Agreement PartyUInfo) invalid`);
                    try {
                        partyUInfo = (0, _base64UrlJs.decode)(joseHeader.apu);
                    } catch (_a) {
                        throw new (0, _errorsJs.JWEInvalid)("Failed to base64url decode the apu");
                    }
                }
                if (joseHeader.apv !== undefined) {
                    if (typeof joseHeader.apv !== "string") throw new (0, _errorsJs.JWEInvalid)(`JOSE Header "apv" (Agreement PartyVInfo) invalid`);
                    try {
                        partyVInfo = (0, _base64UrlJs.decode)(joseHeader.apv);
                    } catch (_b) {
                        throw new (0, _errorsJs.JWEInvalid)("Failed to base64url decode the apv");
                    }
                }
                const sharedSecret = await _ecdhesJs.deriveKey(epk, key, alg === "ECDH-ES" ? joseHeader.enc : alg, alg === "ECDH-ES" ? (0, _cekJs.bitLength)(joseHeader.enc) : parseInt(alg.slice(-5, -2), 10), partyUInfo, partyVInfo);
                if (alg === "ECDH-ES") return sharedSecret;
                if (encryptedKey === undefined) throw new (0, _errorsJs.JWEInvalid)("JWE Encrypted Key missing");
                return (0, _aeskwJs.unwrap)(alg.slice(-6), sharedSecret, encryptedKey);
            }
        case "RSA1_5":
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            if (encryptedKey === undefined) throw new (0, _errorsJs.JWEInvalid)("JWE Encrypted Key missing");
            return (0, _rsaesJs.decrypt)(alg, key, encryptedKey);
        case "PBES2-HS256+A128KW":
        case "PBES2-HS384+A192KW":
        case "PBES2-HS512+A256KW":
            {
                if (encryptedKey === undefined) throw new (0, _errorsJs.JWEInvalid)("JWE Encrypted Key missing");
                if (typeof joseHeader.p2c !== "number") throw new (0, _errorsJs.JWEInvalid)(`JOSE Header "p2c" (PBES2 Count) missing or invalid`);
                const p2cLimit = (options === null || options === void 0 ? void 0 : options.maxPBES2Count) || 10000;
                if (joseHeader.p2c > p2cLimit) throw new (0, _errorsJs.JWEInvalid)(`JOSE Header "p2c" (PBES2 Count) out is of acceptable bounds`);
                if (typeof joseHeader.p2s !== "string") throw new (0, _errorsJs.JWEInvalid)(`JOSE Header "p2s" (PBES2 Salt) missing or invalid`);
                let p2s;
                try {
                    p2s = (0, _base64UrlJs.decode)(joseHeader.p2s);
                } catch (_c) {
                    throw new (0, _errorsJs.JWEInvalid)("Failed to base64url decode the p2s");
                }
                return (0, _pbes2KwJs.decrypt)(alg, key, encryptedKey, joseHeader.p2c, p2s);
            }
        case "A128KW":
        case "A192KW":
        case "A256KW":
            if (encryptedKey === undefined) throw new (0, _errorsJs.JWEInvalid)("JWE Encrypted Key missing");
            return (0, _aeskwJs.unwrap)(alg, key, encryptedKey);
        case "A128GCMKW":
        case "A192GCMKW":
        case "A256GCMKW":
            {
                if (encryptedKey === undefined) throw new (0, _errorsJs.JWEInvalid)("JWE Encrypted Key missing");
                if (typeof joseHeader.iv !== "string") throw new (0, _errorsJs.JWEInvalid)(`JOSE Header "iv" (Initialization Vector) missing or invalid`);
                if (typeof joseHeader.tag !== "string") throw new (0, _errorsJs.JWEInvalid)(`JOSE Header "tag" (Authentication Tag) missing or invalid`);
                let iv;
                try {
                    iv = (0, _base64UrlJs.decode)(joseHeader.iv);
                } catch (_d) {
                    throw new (0, _errorsJs.JWEInvalid)("Failed to base64url decode the iv");
                }
                let tag;
                try {
                    tag = (0, _base64UrlJs.decode)(joseHeader.tag);
                } catch (_e) {
                    throw new (0, _errorsJs.JWEInvalid)("Failed to base64url decode the tag");
                }
                return (0, _aesgcmkwJs.unwrap)(alg, key, encryptedKey, iv, tag);
            }
        default:
            throw new (0, _errorsJs.JOSENotSupported)('Invalid or unsupported "alg" (JWE Algorithm) header value');
    }
}
exports.default = decryptKeyManagement;

},{"../runtime/aeskw.js":"2J708","../runtime/ecdhes.js":"74mdv","../runtime/pbes2kw.js":"43KtE","../runtime/rsaes.js":"3mFhj","../runtime/base64url.js":"8Djx4","../util/errors.js":"4fsOp","../lib/cek.js":"cA5vi","../key/import.js":"661YL","./check_key_type.js":"5ompv","./is_object.js":"daSnu","./aesgcmkw.js":"6zfNV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2J708":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wrap", ()=>wrap);
parcelHelpers.export(exports, "unwrap", ()=>unwrap);
var _bogusJs = require("./bogus.js");
var _bogusJsDefault = parcelHelpers.interopDefault(_bogusJs);
var _webcryptoJs = require("./webcrypto.js");
var _webcryptoJsDefault = parcelHelpers.interopDefault(_webcryptoJs);
var _cryptoKeyJs = require("../lib/crypto_key.js");
var _invalidKeyInputJs = require("../lib/invalid_key_input.js");
var _invalidKeyInputJsDefault = parcelHelpers.interopDefault(_invalidKeyInputJs);
var _isKeyLikeJs = require("./is_key_like.js");
function checkKeySize(key, alg) {
    if (key.algorithm.length !== parseInt(alg.slice(1, 4), 10)) throw new TypeError(`Invalid key size for alg: ${alg}`);
}
function getCryptoKey(key, alg, usage) {
    if ((0, _webcryptoJs.isCryptoKey)(key)) {
        (0, _cryptoKeyJs.checkEncCryptoKey)(key, alg, usage);
        return key;
    }
    if (key instanceof Uint8Array) return (0, _webcryptoJsDefault.default).subtle.importKey("raw", key, "AES-KW", true, [
        usage
    ]);
    throw new TypeError((0, _invalidKeyInputJsDefault.default)(key, ...(0, _isKeyLikeJs.types), "Uint8Array"));
}
const wrap = async (alg, key, cek)=>{
    const cryptoKey = await getCryptoKey(key, alg, "wrapKey");
    checkKeySize(cryptoKey, alg);
    const cryptoKeyCek = await (0, _webcryptoJsDefault.default).subtle.importKey("raw", cek, ...(0, _bogusJsDefault.default));
    return new Uint8Array(await (0, _webcryptoJsDefault.default).subtle.wrapKey("raw", cryptoKeyCek, cryptoKey, "AES-KW"));
};
const unwrap = async (alg, key, encryptedKey)=>{
    const cryptoKey = await getCryptoKey(key, alg, "unwrapKey");
    checkKeySize(cryptoKey, alg);
    const cryptoKeyCek = await (0, _webcryptoJsDefault.default).subtle.unwrapKey("raw", encryptedKey, cryptoKey, "AES-KW", ...(0, _bogusJsDefault.default));
    return new Uint8Array(await (0, _webcryptoJsDefault.default).subtle.exportKey("raw", cryptoKeyCek));
};

},{"./bogus.js":"6Fge1","./webcrypto.js":"aUHBb","../lib/crypto_key.js":"gM0cz","../lib/invalid_key_input.js":"5GTGb","./is_key_like.js":"9kDjz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Fge1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const bogusWebCrypto = [
    {
        hash: "SHA-256",
        name: "HMAC"
    },
    true,
    [
        "sign"
    ]
];
exports.default = bogusWebCrypto;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"74mdv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deriveKey", ()=>deriveKey);
parcelHelpers.export(exports, "generateEpk", ()=>generateEpk);
parcelHelpers.export(exports, "ecdhAllowed", ()=>ecdhAllowed);
var _bufferUtilsJs = require("../lib/buffer_utils.js");
var _webcryptoJs = require("./webcrypto.js");
var _webcryptoJsDefault = parcelHelpers.interopDefault(_webcryptoJs);
var _cryptoKeyJs = require("../lib/crypto_key.js");
var _invalidKeyInputJs = require("../lib/invalid_key_input.js");
var _invalidKeyInputJsDefault = parcelHelpers.interopDefault(_invalidKeyInputJs);
var _isKeyLikeJs = require("./is_key_like.js");
async function deriveKey(publicKey, privateKey, algorithm, keyLength, apu = new Uint8Array(0), apv = new Uint8Array(0)) {
    if (!(0, _webcryptoJs.isCryptoKey)(publicKey)) throw new TypeError((0, _invalidKeyInputJsDefault.default)(publicKey, ...(0, _isKeyLikeJs.types)));
    (0, _cryptoKeyJs.checkEncCryptoKey)(publicKey, "ECDH");
    if (!(0, _webcryptoJs.isCryptoKey)(privateKey)) throw new TypeError((0, _invalidKeyInputJsDefault.default)(privateKey, ...(0, _isKeyLikeJs.types)));
    (0, _cryptoKeyJs.checkEncCryptoKey)(privateKey, "ECDH", "deriveBits");
    const value = (0, _bufferUtilsJs.concat)((0, _bufferUtilsJs.lengthAndInput)((0, _bufferUtilsJs.encoder).encode(algorithm)), (0, _bufferUtilsJs.lengthAndInput)(apu), (0, _bufferUtilsJs.lengthAndInput)(apv), (0, _bufferUtilsJs.uint32be)(keyLength));
    let length;
    if (publicKey.algorithm.name === "X25519") length = 256;
    else if (publicKey.algorithm.name === "X448") length = 448;
    else length = Math.ceil(parseInt(publicKey.algorithm.namedCurve.substr(-3), 10) / 8) << 3;
    const sharedSecret = new Uint8Array(await (0, _webcryptoJsDefault.default).subtle.deriveBits({
        name: publicKey.algorithm.name,
        public: publicKey
    }, privateKey, length));
    return (0, _bufferUtilsJs.concatKdf)(sharedSecret, keyLength, value);
}
async function generateEpk(key) {
    if (!(0, _webcryptoJs.isCryptoKey)(key)) throw new TypeError((0, _invalidKeyInputJsDefault.default)(key, ...(0, _isKeyLikeJs.types)));
    return (0, _webcryptoJsDefault.default).subtle.generateKey(key.algorithm, true, [
        "deriveBits"
    ]);
}
function ecdhAllowed(key) {
    if (!(0, _webcryptoJs.isCryptoKey)(key)) throw new TypeError((0, _invalidKeyInputJsDefault.default)(key, ...(0, _isKeyLikeJs.types)));
    return [
        "P-256",
        "P-384",
        "P-521"
    ].includes(key.algorithm.namedCurve) || key.algorithm.name === "X25519" || key.algorithm.name === "X448";
}

},{"../lib/buffer_utils.js":"h0x9u","./webcrypto.js":"aUHBb","../lib/crypto_key.js":"gM0cz","../lib/invalid_key_input.js":"5GTGb","./is_key_like.js":"9kDjz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"43KtE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "encrypt", ()=>encrypt);
parcelHelpers.export(exports, "decrypt", ()=>decrypt);
var _randomJs = require("./random.js");
var _randomJsDefault = parcelHelpers.interopDefault(_randomJs);
var _bufferUtilsJs = require("../lib/buffer_utils.js");
var _base64UrlJs = require("./base64url.js");
var _aeskwJs = require("./aeskw.js");
var _checkP2SJs = require("../lib/check_p2s.js");
var _checkP2SJsDefault = parcelHelpers.interopDefault(_checkP2SJs);
var _webcryptoJs = require("./webcrypto.js");
var _webcryptoJsDefault = parcelHelpers.interopDefault(_webcryptoJs);
var _cryptoKeyJs = require("../lib/crypto_key.js");
var _invalidKeyInputJs = require("../lib/invalid_key_input.js");
var _invalidKeyInputJsDefault = parcelHelpers.interopDefault(_invalidKeyInputJs);
var _isKeyLikeJs = require("./is_key_like.js");
function getCryptoKey(key, alg) {
    if (key instanceof Uint8Array) return (0, _webcryptoJsDefault.default).subtle.importKey("raw", key, "PBKDF2", false, [
        "deriveBits"
    ]);
    if ((0, _webcryptoJs.isCryptoKey)(key)) {
        (0, _cryptoKeyJs.checkEncCryptoKey)(key, alg, "deriveBits", "deriveKey");
        return key;
    }
    throw new TypeError((0, _invalidKeyInputJsDefault.default)(key, ...(0, _isKeyLikeJs.types), "Uint8Array"));
}
async function deriveKey(p2s, alg, p2c, key) {
    (0, _checkP2SJsDefault.default)(p2s);
    const salt = (0, _bufferUtilsJs.p2s)(alg, p2s);
    const keylen = parseInt(alg.slice(13, 16), 10);
    const subtleAlg = {
        hash: `SHA-${alg.slice(8, 11)}`,
        iterations: p2c,
        name: "PBKDF2",
        salt
    };
    const wrapAlg = {
        length: keylen,
        name: "AES-KW"
    };
    const cryptoKey = await getCryptoKey(key, alg);
    if (cryptoKey.usages.includes("deriveBits")) return new Uint8Array(await (0, _webcryptoJsDefault.default).subtle.deriveBits(subtleAlg, cryptoKey, keylen));
    if (cryptoKey.usages.includes("deriveKey")) return (0, _webcryptoJsDefault.default).subtle.deriveKey(subtleAlg, cryptoKey, wrapAlg, false, [
        "wrapKey",
        "unwrapKey"
    ]);
    throw new TypeError('PBKDF2 key "usages" must include "deriveBits" or "deriveKey"');
}
const encrypt = async (alg, key, cek, p2c = 2048, p2s = (0, _randomJsDefault.default)(new Uint8Array(16)))=>{
    const derived = await deriveKey(p2s, alg, p2c, key);
    const encryptedKey = await (0, _aeskwJs.wrap)(alg.slice(-6), derived, cek);
    return {
        encryptedKey,
        p2c,
        p2s: (0, _base64UrlJs.encode)(p2s)
    };
};
const decrypt = async (alg, key, encryptedKey, p2c, p2s)=>{
    const derived = await deriveKey(p2s, alg, p2c, key);
    return (0, _aeskwJs.unwrap)(alg.slice(-6), derived, encryptedKey);
};

},{"./random.js":"4nPoE","../lib/buffer_utils.js":"h0x9u","./base64url.js":"8Djx4","./aeskw.js":"2J708","../lib/check_p2s.js":"4YP4w","./webcrypto.js":"aUHBb","../lib/crypto_key.js":"gM0cz","../lib/invalid_key_input.js":"5GTGb","./is_key_like.js":"9kDjz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4YP4w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>checkP2s);
var _errorsJs = require("../util/errors.js");
function checkP2s(p2s) {
    if (!(p2s instanceof Uint8Array) || p2s.length < 8) throw new (0, _errorsJs.JWEInvalid)("PBES2 Salt Input must be 8 or more octets");
}

},{"../util/errors.js":"4fsOp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3mFhj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "encrypt", ()=>encrypt);
parcelHelpers.export(exports, "decrypt", ()=>decrypt);
var _subtleRsaesJs = require("./subtle_rsaes.js");
var _subtleRsaesJsDefault = parcelHelpers.interopDefault(_subtleRsaesJs);
var _bogusJs = require("./bogus.js");
var _bogusJsDefault = parcelHelpers.interopDefault(_bogusJs);
var _webcryptoJs = require("./webcrypto.js");
var _webcryptoJsDefault = parcelHelpers.interopDefault(_webcryptoJs);
var _cryptoKeyJs = require("../lib/crypto_key.js");
var _checkKeyLengthJs = require("./check_key_length.js");
var _checkKeyLengthJsDefault = parcelHelpers.interopDefault(_checkKeyLengthJs);
var _invalidKeyInputJs = require("../lib/invalid_key_input.js");
var _invalidKeyInputJsDefault = parcelHelpers.interopDefault(_invalidKeyInputJs);
var _isKeyLikeJs = require("./is_key_like.js");
const encrypt = async (alg, key, cek)=>{
    if (!(0, _webcryptoJs.isCryptoKey)(key)) throw new TypeError((0, _invalidKeyInputJsDefault.default)(key, ...(0, _isKeyLikeJs.types)));
    (0, _cryptoKeyJs.checkEncCryptoKey)(key, alg, "encrypt", "wrapKey");
    (0, _checkKeyLengthJsDefault.default)(alg, key);
    if (key.usages.includes("encrypt")) return new Uint8Array(await (0, _webcryptoJsDefault.default).subtle.encrypt((0, _subtleRsaesJsDefault.default)(alg), key, cek));
    if (key.usages.includes("wrapKey")) {
        const cryptoKeyCek = await (0, _webcryptoJsDefault.default).subtle.importKey("raw", cek, ...(0, _bogusJsDefault.default));
        return new Uint8Array(await (0, _webcryptoJsDefault.default).subtle.wrapKey("raw", cryptoKeyCek, key, (0, _subtleRsaesJsDefault.default)(alg)));
    }
    throw new TypeError('RSA-OAEP key "usages" must include "encrypt" or "wrapKey" for this operation');
};
const decrypt = async (alg, key, encryptedKey)=>{
    if (!(0, _webcryptoJs.isCryptoKey)(key)) throw new TypeError((0, _invalidKeyInputJsDefault.default)(key, ...(0, _isKeyLikeJs.types)));
    (0, _cryptoKeyJs.checkEncCryptoKey)(key, alg, "decrypt", "unwrapKey");
    (0, _checkKeyLengthJsDefault.default)(alg, key);
    if (key.usages.includes("decrypt")) return new Uint8Array(await (0, _webcryptoJsDefault.default).subtle.decrypt((0, _subtleRsaesJsDefault.default)(alg), key, encryptedKey));
    if (key.usages.includes("unwrapKey")) {
        const cryptoKeyCek = await (0, _webcryptoJsDefault.default).subtle.unwrapKey("raw", encryptedKey, key, (0, _subtleRsaesJsDefault.default)(alg), ...(0, _bogusJsDefault.default));
        return new Uint8Array(await (0, _webcryptoJsDefault.default).subtle.exportKey("raw", cryptoKeyCek));
    }
    throw new TypeError('RSA-OAEP key "usages" must include "decrypt" or "unwrapKey" for this operation');
};

},{"./subtle_rsaes.js":"jqv9c","./bogus.js":"6Fge1","./webcrypto.js":"aUHBb","../lib/crypto_key.js":"gM0cz","./check_key_length.js":"0CfW9","../lib/invalid_key_input.js":"5GTGb","./is_key_like.js":"9kDjz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jqv9c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subtleRsaEs);
var _errorsJs = require("../util/errors.js");
function subtleRsaEs(alg) {
    switch(alg){
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            return "RSA-OAEP";
        default:
            throw new (0, _errorsJs.JOSENotSupported)(`alg ${alg} is not supported either by JOSE or your javascript runtime`);
    }
}

},{"../util/errors.js":"4fsOp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"0CfW9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (alg, key)=>{
    if (alg.startsWith("RS") || alg.startsWith("PS")) {
        const { modulusLength } = key.algorithm;
        if (typeof modulusLength !== "number" || modulusLength < 2048) throw new TypeError(`${alg} requires key modulusLength to be 2048 bits or larger`);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cA5vi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bitLength", ()=>bitLength);
var _errorsJs = require("../util/errors.js");
var _randomJs = require("../runtime/random.js");
var _randomJsDefault = parcelHelpers.interopDefault(_randomJs);
function bitLength(alg) {
    switch(alg){
        case "A128GCM":
            return 128;
        case "A192GCM":
            return 192;
        case "A256GCM":
        case "A128CBC-HS256":
            return 256;
        case "A192CBC-HS384":
            return 384;
        case "A256CBC-HS512":
            return 512;
        default:
            throw new (0, _errorsJs.JOSENotSupported)(`Unsupported JWE Algorithm: ${alg}`);
    }
}
exports.default = (alg)=>(0, _randomJsDefault.default)(new Uint8Array(bitLength(alg) >> 3));

},{"../util/errors.js":"4fsOp","../runtime/random.js":"4nPoE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"661YL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "importSPKI", ()=>importSPKI);
parcelHelpers.export(exports, "importX509", ()=>importX509);
parcelHelpers.export(exports, "importPKCS8", ()=>importPKCS8);
parcelHelpers.export(exports, "importJWK", ()=>importJWK);
var _base64UrlJs = require("../runtime/base64url.js");
var _asn1Js = require("../runtime/asn1.js");
var _jwkToKeyJs = require("../runtime/jwk_to_key.js");
var _jwkToKeyJsDefault = parcelHelpers.interopDefault(_jwkToKeyJs);
var _errorsJs = require("../util/errors.js");
var _isObjectJs = require("../lib/is_object.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
async function importSPKI(spki, alg, options) {
    if (typeof spki !== "string" || spki.indexOf("-----BEGIN PUBLIC KEY-----") !== 0) throw new TypeError('"spki" must be SPKI formatted string');
    return (0, _asn1Js.fromSPKI)(spki, alg, options);
}
async function importX509(x509, alg, options) {
    if (typeof x509 !== "string" || x509.indexOf("-----BEGIN CERTIFICATE-----") !== 0) throw new TypeError('"x509" must be X.509 formatted string');
    return (0, _asn1Js.fromX509)(x509, alg, options);
}
async function importPKCS8(pkcs8, alg, options) {
    if (typeof pkcs8 !== "string" || pkcs8.indexOf("-----BEGIN PRIVATE KEY-----") !== 0) throw new TypeError('"pkcs8" must be PKCS#8 formatted string');
    return (0, _asn1Js.fromPKCS8)(pkcs8, alg, options);
}
async function importJWK(jwk, alg, octAsKeyObject) {
    var _a;
    if (!(0, _isObjectJsDefault.default)(jwk)) throw new TypeError("JWK must be an object");
    alg || (alg = jwk.alg);
    switch(jwk.kty){
        case "oct":
            if (typeof jwk.k !== "string" || !jwk.k) throw new TypeError('missing "k" (Key Value) Parameter value');
            octAsKeyObject !== null && octAsKeyObject !== void 0 ? octAsKeyObject : octAsKeyObject = jwk.ext !== true;
            if (octAsKeyObject) return (0, _jwkToKeyJsDefault.default)({
                ...jwk,
                alg,
                ext: (_a = jwk.ext) !== null && _a !== void 0 ? _a : false
            });
            return (0, _base64UrlJs.decode)(jwk.k);
        case "RSA":
            if (jwk.oth !== undefined) throw new (0, _errorsJs.JOSENotSupported)('RSA JWK "oth" (Other Primes Info) Parameter value is not supported');
        case "EC":
        case "OKP":
            return (0, _jwkToKeyJsDefault.default)({
                ...jwk,
                alg
            });
        default:
            throw new (0, _errorsJs.JOSENotSupported)('Unsupported "kty" (Key Type) Parameter value');
    }
}

},{"../runtime/base64url.js":"8Djx4","../runtime/asn1.js":"CWUVr","../runtime/jwk_to_key.js":"1ZP72","../util/errors.js":"4fsOp","../lib/is_object.js":"daSnu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"CWUVr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toSPKI", ()=>toSPKI);
parcelHelpers.export(exports, "toPKCS8", ()=>toPKCS8);
parcelHelpers.export(exports, "fromPKCS8", ()=>fromPKCS8);
parcelHelpers.export(exports, "fromSPKI", ()=>fromSPKI);
parcelHelpers.export(exports, "fromX509", ()=>fromX509);
var _webcryptoJs = require("./webcrypto.js");
var _webcryptoJsDefault = parcelHelpers.interopDefault(_webcryptoJs);
var _invalidKeyInputJs = require("../lib/invalid_key_input.js");
var _invalidKeyInputJsDefault = parcelHelpers.interopDefault(_invalidKeyInputJs);
var _base64UrlJs = require("./base64url.js");
var _formatPemJs = require("../lib/format_pem.js");
var _formatPemJsDefault = parcelHelpers.interopDefault(_formatPemJs);
var _errorsJs = require("../util/errors.js");
var _isKeyLikeJs = require("./is_key_like.js");
const genericExport = async (keyType, keyFormat, key)=>{
    if (!(0, _webcryptoJs.isCryptoKey)(key)) throw new TypeError((0, _invalidKeyInputJsDefault.default)(key, ...(0, _isKeyLikeJs.types)));
    if (!key.extractable) throw new TypeError("CryptoKey is not extractable");
    if (key.type !== keyType) throw new TypeError(`key is not a ${keyType} key`);
    return (0, _formatPemJsDefault.default)((0, _base64UrlJs.encodeBase64)(new Uint8Array(await (0, _webcryptoJsDefault.default).subtle.exportKey(keyFormat, key))), `${keyType.toUpperCase()} KEY`);
};
const toSPKI = (key)=>{
    return genericExport("public", "spki", key);
};
const toPKCS8 = (key)=>{
    return genericExport("private", "pkcs8", key);
};
const findOid = (keyData, oid, from = 0)=>{
    if (from === 0) {
        oid.unshift(oid.length);
        oid.unshift(0x06);
    }
    let i = keyData.indexOf(oid[0], from);
    if (i === -1) return false;
    const sub = keyData.subarray(i, i + oid.length);
    if (sub.length !== oid.length) return false;
    return sub.every((value, index)=>value === oid[index]) || findOid(keyData, oid, i + 1);
};
const getNamedCurve = (keyData)=>{
    switch(true){
        case findOid(keyData, [
            0x2a,
            0x86,
            0x48,
            0xce,
            0x3d,
            0x03,
            0x01,
            0x07
        ]):
            return "P-256";
        case findOid(keyData, [
            0x2b,
            0x81,
            0x04,
            0x00,
            0x22
        ]):
            return "P-384";
        case findOid(keyData, [
            0x2b,
            0x81,
            0x04,
            0x00,
            0x23
        ]):
            return "P-521";
        case findOid(keyData, [
            0x2b,
            0x65,
            0x6e
        ]):
            return "X25519";
        case findOid(keyData, [
            0x2b,
            0x65,
            0x6f
        ]):
            return "X448";
        case findOid(keyData, [
            0x2b,
            0x65,
            0x70
        ]):
            return "Ed25519";
        case findOid(keyData, [
            0x2b,
            0x65,
            0x71
        ]):
            return "Ed448";
        default:
            throw new (0, _errorsJs.JOSENotSupported)("Invalid or unsupported EC Key Curve or OKP Key Sub Type");
    }
};
const genericImport = async (replace, keyFormat, pem, alg, options)=>{
    var _a;
    let algorithm;
    let keyUsages;
    const keyData = new Uint8Array(atob(pem.replace(replace, "")).split("").map((c)=>c.charCodeAt(0)));
    const isPublic = keyFormat === "spki";
    switch(alg){
        case "PS256":
        case "PS384":
        case "PS512":
            algorithm = {
                name: "RSA-PSS",
                hash: `SHA-${alg.slice(-3)}`
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "RS256":
        case "RS384":
        case "RS512":
            algorithm = {
                name: "RSASSA-PKCS1-v1_5",
                hash: `SHA-${alg.slice(-3)}`
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            algorithm = {
                name: "RSA-OAEP",
                hash: `SHA-${parseInt(alg.slice(-3), 10) || 1}`
            };
            keyUsages = isPublic ? [
                "encrypt",
                "wrapKey"
            ] : [
                "decrypt",
                "unwrapKey"
            ];
            break;
        case "ES256":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-256"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ES384":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-384"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ES512":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-521"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                const namedCurve = getNamedCurve(keyData);
                algorithm = namedCurve.startsWith("P-") ? {
                    name: "ECDH",
                    namedCurve
                } : {
                    name: namedCurve
                };
                keyUsages = isPublic ? [] : [
                    "deriveBits"
                ];
                break;
            }
        case "EdDSA":
            algorithm = {
                name: getNamedCurve(keyData)
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        default:
            throw new (0, _errorsJs.JOSENotSupported)('Invalid or unsupported "alg" (Algorithm) value');
    }
    return (0, _webcryptoJsDefault.default).subtle.importKey(keyFormat, keyData, algorithm, (_a = options === null || options === void 0 ? void 0 : options.extractable) !== null && _a !== void 0 ? _a : false, keyUsages);
};
const fromPKCS8 = (pem, alg, options)=>{
    return genericImport(/(?:-----(?:BEGIN|END) PRIVATE KEY-----|\s)/g, "pkcs8", pem, alg, options);
};
const fromSPKI = (pem, alg, options)=>{
    return genericImport(/(?:-----(?:BEGIN|END) PUBLIC KEY-----|\s)/g, "spki", pem, alg, options);
};
function getElement(seq) {
    let result = [];
    let next = 0;
    while(next < seq.length){
        let nextPart = parseElement(seq.subarray(next));
        result.push(nextPart);
        next += nextPart.byteLength;
    }
    return result;
}
function parseElement(bytes) {
    let position = 0;
    let tag = bytes[0] & 0x1f;
    position++;
    if (tag === 0x1f) {
        tag = 0;
        while(bytes[position] >= 0x80){
            tag = tag * 128 + bytes[position] - 0x80;
            position++;
        }
        tag = tag * 128 + bytes[position] - 0x80;
        position++;
    }
    let length = 0;
    if (bytes[position] < 0x80) {
        length = bytes[position];
        position++;
    } else if (length === 0x80) {
        length = 0;
        while(bytes[position + length] !== 0 || bytes[position + length + 1] !== 0){
            if (length > bytes.byteLength) throw new TypeError("invalid indefinite form length");
            length++;
        }
        const byteLength = position + length + 2;
        return {
            byteLength,
            contents: bytes.subarray(position, position + length),
            raw: bytes.subarray(0, byteLength)
        };
    } else {
        let numberOfDigits = bytes[position] & 0x7f;
        position++;
        length = 0;
        for(let i = 0; i < numberOfDigits; i++){
            length = length * 256 + bytes[position];
            position++;
        }
    }
    const byteLength = position + length;
    return {
        byteLength,
        contents: bytes.subarray(position, byteLength),
        raw: bytes.subarray(0, byteLength)
    };
}
function spkiFromX509(buf) {
    const tbsCertificate = getElement(getElement(parseElement(buf).contents)[0].contents);
    return (0, _base64UrlJs.encodeBase64)(tbsCertificate[tbsCertificate[0].raw[0] === 0xa0 ? 6 : 5].raw);
}
function getSPKI(x509) {
    const pem = x509.replace(/(?:-----(?:BEGIN|END) CERTIFICATE-----|\s)/g, "");
    const raw = (0, _base64UrlJs.decodeBase64)(pem);
    return (0, _formatPemJsDefault.default)(spkiFromX509(raw), "PUBLIC KEY");
}
const fromX509 = (pem, alg, options)=>{
    let spki;
    try {
        spki = getSPKI(pem);
    } catch (cause) {
        throw new TypeError("Failed to parse the X.509 certificate", {
            cause
        });
    }
    return fromSPKI(spki, alg, options);
};

},{"./webcrypto.js":"aUHBb","../lib/invalid_key_input.js":"5GTGb","./base64url.js":"8Djx4","../lib/format_pem.js":"47l3h","../util/errors.js":"4fsOp","./is_key_like.js":"9kDjz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"47l3h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (b64, descriptor)=>{
    const newlined = (b64.match(/.{1,64}/g) || []).join("\n");
    return `-----BEGIN ${descriptor}-----\n${newlined}\n-----END ${descriptor}-----`;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1ZP72":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _webcryptoJs = require("./webcrypto.js");
var _webcryptoJsDefault = parcelHelpers.interopDefault(_webcryptoJs);
var _errorsJs = require("../util/errors.js");
var _base64UrlJs = require("./base64url.js");
function subtleMapping(jwk) {
    let algorithm;
    let keyUsages;
    switch(jwk.kty){
        case "oct":
            switch(jwk.alg){
                case "HS256":
                case "HS384":
                case "HS512":
                    algorithm = {
                        name: "HMAC",
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = [
                        "sign",
                        "verify"
                    ];
                    break;
                case "A128CBC-HS256":
                case "A192CBC-HS384":
                case "A256CBC-HS512":
                    throw new (0, _errorsJs.JOSENotSupported)(`${jwk.alg} keys cannot be imported as CryptoKey instances`);
                case "A128GCM":
                case "A192GCM":
                case "A256GCM":
                case "A128GCMKW":
                case "A192GCMKW":
                case "A256GCMKW":
                    algorithm = {
                        name: "AES-GCM"
                    };
                    keyUsages = [
                        "encrypt",
                        "decrypt"
                    ];
                    break;
                case "A128KW":
                case "A192KW":
                case "A256KW":
                    algorithm = {
                        name: "AES-KW"
                    };
                    keyUsages = [
                        "wrapKey",
                        "unwrapKey"
                    ];
                    break;
                case "PBES2-HS256+A128KW":
                case "PBES2-HS384+A192KW":
                case "PBES2-HS512+A256KW":
                    algorithm = {
                        name: "PBKDF2"
                    };
                    keyUsages = [
                        "deriveBits"
                    ];
                    break;
                default:
                    throw new (0, _errorsJs.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case "RSA":
            switch(jwk.alg){
                case "PS256":
                case "PS384":
                case "PS512":
                    algorithm = {
                        name: "RSA-PSS",
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "RS256":
                case "RS384":
                case "RS512":
                    algorithm = {
                        name: "RSASSA-PKCS1-v1_5",
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "RSA-OAEP":
                case "RSA-OAEP-256":
                case "RSA-OAEP-384":
                case "RSA-OAEP-512":
                    algorithm = {
                        name: "RSA-OAEP",
                        hash: `SHA-${parseInt(jwk.alg.slice(-3), 10) || 1}`
                    };
                    keyUsages = jwk.d ? [
                        "decrypt",
                        "unwrapKey"
                    ] : [
                        "encrypt",
                        "wrapKey"
                    ];
                    break;
                default:
                    throw new (0, _errorsJs.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case "EC":
            switch(jwk.alg){
                case "ES256":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-256"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ES384":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-384"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ES512":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-521"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ECDH-ES":
                case "ECDH-ES+A128KW":
                case "ECDH-ES+A192KW":
                case "ECDH-ES+A256KW":
                    algorithm = {
                        name: "ECDH",
                        namedCurve: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "deriveBits"
                    ] : [];
                    break;
                default:
                    throw new (0, _errorsJs.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case "OKP":
            switch(jwk.alg){
                case "EdDSA":
                    algorithm = {
                        name: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ECDH-ES":
                case "ECDH-ES+A128KW":
                case "ECDH-ES+A192KW":
                case "ECDH-ES+A256KW":
                    algorithm = {
                        name: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "deriveBits"
                    ] : [];
                    break;
                default:
                    throw new (0, _errorsJs.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        default:
            throw new (0, _errorsJs.JOSENotSupported)('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
    }
    return {
        algorithm,
        keyUsages
    };
}
const parse = async (jwk)=>{
    var _a, _b;
    if (!jwk.alg) throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
    const { algorithm, keyUsages } = subtleMapping(jwk);
    const rest = [
        algorithm,
        (_a = jwk.ext) !== null && _a !== void 0 ? _a : false,
        (_b = jwk.key_ops) !== null && _b !== void 0 ? _b : keyUsages
    ];
    if (algorithm.name === "PBKDF2") return (0, _webcryptoJsDefault.default).subtle.importKey("raw", (0, _base64UrlJs.decode)(jwk.k), ...rest);
    const keyData = {
        ...jwk
    };
    delete keyData.alg;
    delete keyData.use;
    return (0, _webcryptoJsDefault.default).subtle.importKey("jwk", keyData, ...rest);
};
exports.default = parse;

},{"./webcrypto.js":"aUHBb","../util/errors.js":"4fsOp","./base64url.js":"8Djx4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5ompv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _invalidKeyInputJs = require("./invalid_key_input.js");
var _isKeyLikeJs = require("../runtime/is_key_like.js");
var _isKeyLikeJsDefault = parcelHelpers.interopDefault(_isKeyLikeJs);
const symmetricTypeCheck = (alg, key)=>{
    if (key instanceof Uint8Array) return;
    if (!(0, _isKeyLikeJsDefault.default)(key)) throw new TypeError((0, _invalidKeyInputJs.withAlg)(alg, key, ...(0, _isKeyLikeJs.types), "Uint8Array"));
    if (key.type !== "secret") throw new TypeError(`${(0, _isKeyLikeJs.types).join(" or ")} instances for symmetric algorithms must be of type "secret"`);
};
const asymmetricTypeCheck = (alg, key, usage)=>{
    if (!(0, _isKeyLikeJsDefault.default)(key)) throw new TypeError((0, _invalidKeyInputJs.withAlg)(alg, key, ...(0, _isKeyLikeJs.types)));
    if (key.type === "secret") throw new TypeError(`${(0, _isKeyLikeJs.types).join(" or ")} instances for asymmetric algorithms must not be of type "secret"`);
    if (usage === "sign" && key.type === "public") throw new TypeError(`${(0, _isKeyLikeJs.types).join(" or ")} instances for asymmetric algorithm signing must be of type "private"`);
    if (usage === "decrypt" && key.type === "public") throw new TypeError(`${(0, _isKeyLikeJs.types).join(" or ")} instances for asymmetric algorithm decryption must be of type "private"`);
    if (key.algorithm && usage === "verify" && key.type === "private") throw new TypeError(`${(0, _isKeyLikeJs.types).join(" or ")} instances for asymmetric algorithm verifying must be of type "public"`);
    if (key.algorithm && usage === "encrypt" && key.type === "private") throw new TypeError(`${(0, _isKeyLikeJs.types).join(" or ")} instances for asymmetric algorithm encryption must be of type "public"`);
};
const checkKeyType = (alg, key, usage)=>{
    const symmetric = alg.startsWith("HS") || alg === "dir" || alg.startsWith("PBES2") || /^A\d{3}(?:GCM)?KW$/.test(alg);
    if (symmetric) symmetricTypeCheck(alg, key);
    else asymmetricTypeCheck(alg, key, usage);
};
exports.default = checkKeyType;

},{"./invalid_key_input.js":"5GTGb","../runtime/is_key_like.js":"9kDjz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6zfNV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wrap", ()=>wrap);
parcelHelpers.export(exports, "unwrap", ()=>unwrap);
var _encryptJs = require("../runtime/encrypt.js");
var _encryptJsDefault = parcelHelpers.interopDefault(_encryptJs);
var _decryptJs = require("../runtime/decrypt.js");
var _decryptJsDefault = parcelHelpers.interopDefault(_decryptJs);
var _ivJs = require("./iv.js");
var _ivJsDefault = parcelHelpers.interopDefault(_ivJs);
var _base64UrlJs = require("../runtime/base64url.js");
async function wrap(alg, key, cek, iv) {
    const jweAlgorithm = alg.slice(0, 7);
    iv || (iv = (0, _ivJsDefault.default)(jweAlgorithm));
    const { ciphertext: encryptedKey, tag } = await (0, _encryptJsDefault.default)(jweAlgorithm, cek, key, iv, new Uint8Array(0));
    return {
        encryptedKey,
        iv: (0, _base64UrlJs.encode)(iv),
        tag: (0, _base64UrlJs.encode)(tag)
    };
}
async function unwrap(alg, key, encryptedKey, iv, tag) {
    const jweAlgorithm = alg.slice(0, 7);
    return (0, _decryptJsDefault.default)(jweAlgorithm, key, encryptedKey, iv, tag, new Uint8Array(0));
}

},{"../runtime/encrypt.js":"lfNrn","../runtime/decrypt.js":"dPMLp","./iv.js":"bvMJc","../runtime/base64url.js":"8Djx4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lfNrn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _bufferUtilsJs = require("../lib/buffer_utils.js");
var _checkIvLengthJs = require("../lib/check_iv_length.js");
var _checkIvLengthJsDefault = parcelHelpers.interopDefault(_checkIvLengthJs);
var _checkCekLengthJs = require("./check_cek_length.js");
var _checkCekLengthJsDefault = parcelHelpers.interopDefault(_checkCekLengthJs);
var _webcryptoJs = require("./webcrypto.js");
var _webcryptoJsDefault = parcelHelpers.interopDefault(_webcryptoJs);
var _cryptoKeyJs = require("../lib/crypto_key.js");
var _invalidKeyInputJs = require("../lib/invalid_key_input.js");
var _invalidKeyInputJsDefault = parcelHelpers.interopDefault(_invalidKeyInputJs);
var _errorsJs = require("../util/errors.js");
var _isKeyLikeJs = require("./is_key_like.js");
async function cbcEncrypt(enc, plaintext, cek, iv, aad) {
    if (!(cek instanceof Uint8Array)) throw new TypeError((0, _invalidKeyInputJsDefault.default)(cek, "Uint8Array"));
    const keySize = parseInt(enc.slice(1, 4), 10);
    const encKey = await (0, _webcryptoJsDefault.default).subtle.importKey("raw", cek.subarray(keySize >> 3), "AES-CBC", false, [
        "encrypt"
    ]);
    const macKey = await (0, _webcryptoJsDefault.default).subtle.importKey("raw", cek.subarray(0, keySize >> 3), {
        hash: `SHA-${keySize << 1}`,
        name: "HMAC"
    }, false, [
        "sign"
    ]);
    const ciphertext = new Uint8Array(await (0, _webcryptoJsDefault.default).subtle.encrypt({
        iv,
        name: "AES-CBC"
    }, encKey, plaintext));
    const macData = (0, _bufferUtilsJs.concat)(aad, iv, ciphertext, (0, _bufferUtilsJs.uint64be)(aad.length << 3));
    const tag = new Uint8Array((await (0, _webcryptoJsDefault.default).subtle.sign("HMAC", macKey, macData)).slice(0, keySize >> 3));
    return {
        ciphertext,
        tag
    };
}
async function gcmEncrypt(enc, plaintext, cek, iv, aad) {
    let encKey;
    if (cek instanceof Uint8Array) encKey = await (0, _webcryptoJsDefault.default).subtle.importKey("raw", cek, "AES-GCM", false, [
        "encrypt"
    ]);
    else {
        (0, _cryptoKeyJs.checkEncCryptoKey)(cek, enc, "encrypt");
        encKey = cek;
    }
    const encrypted = new Uint8Array(await (0, _webcryptoJsDefault.default).subtle.encrypt({
        additionalData: aad,
        iv,
        name: "AES-GCM",
        tagLength: 128
    }, encKey, plaintext));
    const tag = encrypted.slice(-16);
    const ciphertext = encrypted.slice(0, -16);
    return {
        ciphertext,
        tag
    };
}
const encrypt = async (enc, plaintext, cek, iv, aad)=>{
    if (!(0, _webcryptoJs.isCryptoKey)(cek) && !(cek instanceof Uint8Array)) throw new TypeError((0, _invalidKeyInputJsDefault.default)(cek, ...(0, _isKeyLikeJs.types), "Uint8Array"));
    (0, _checkIvLengthJsDefault.default)(enc, iv);
    switch(enc){
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            if (cek instanceof Uint8Array) (0, _checkCekLengthJsDefault.default)(cek, parseInt(enc.slice(-3), 10));
            return cbcEncrypt(enc, plaintext, cek, iv, aad);
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            if (cek instanceof Uint8Array) (0, _checkCekLengthJsDefault.default)(cek, parseInt(enc.slice(1, 4), 10));
            return gcmEncrypt(enc, plaintext, cek, iv, aad);
        default:
            throw new (0, _errorsJs.JOSENotSupported)("Unsupported JWE Content Encryption Algorithm");
    }
};
exports.default = encrypt;

},{"../lib/buffer_utils.js":"h0x9u","../lib/check_iv_length.js":"7za2M","./check_cek_length.js":"9VrK5","./webcrypto.js":"aUHBb","../lib/crypto_key.js":"gM0cz","../lib/invalid_key_input.js":"5GTGb","../util/errors.js":"4fsOp","./is_key_like.js":"9kDjz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1cFtE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _errorsJs = require("../util/errors.js");
function validateCrit(Err, recognizedDefault, recognizedOption, protectedHeader, joseHeader) {
    if (joseHeader.crit !== undefined && protectedHeader.crit === undefined) throw new Err('"crit" (Critical) Header Parameter MUST be integrity protected');
    if (!protectedHeader || protectedHeader.crit === undefined) return new Set();
    if (!Array.isArray(protectedHeader.crit) || protectedHeader.crit.length === 0 || protectedHeader.crit.some((input)=>typeof input !== "string" || input.length === 0)) throw new Err('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
    let recognized;
    if (recognizedOption !== undefined) recognized = new Map([
        ...Object.entries(recognizedOption),
        ...recognizedDefault.entries()
    ]);
    else recognized = recognizedDefault;
    for (const parameter of protectedHeader.crit){
        if (!recognized.has(parameter)) throw new (0, _errorsJs.JOSENotSupported)(`Extension Header Parameter "${parameter}" is not recognized`);
        if (joseHeader[parameter] === undefined) throw new Err(`Extension Header Parameter "${parameter}" is missing`);
        else if (recognized.get(parameter) && protectedHeader[parameter] === undefined) throw new Err(`Extension Header Parameter "${parameter}" MUST be integrity protected`);
    }
    return new Set(protectedHeader.crit);
}
exports.default = validateCrit;

},{"../util/errors.js":"4fsOp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fDDwK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const validateAlgorithms = (option, algorithms)=>{
    if (algorithms !== undefined && (!Array.isArray(algorithms) || algorithms.some((s)=>typeof s !== "string"))) throw new TypeError(`"${option}" option must be an array of strings`);
    if (!algorithms) return undefined;
    return new Set(algorithms);
};
exports.default = validateAlgorithms;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"av2Hr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generalDecrypt", ()=>generalDecrypt);
var _decryptJs = require("../flattened/decrypt.js");
var _errorsJs = require("../../util/errors.js");
var _isObjectJs = require("../../lib/is_object.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
async function generalDecrypt(jwe, key, options) {
    if (!(0, _isObjectJsDefault.default)(jwe)) throw new (0, _errorsJs.JWEInvalid)("General JWE must be an object");
    if (!Array.isArray(jwe.recipients) || !jwe.recipients.every((0, _isObjectJsDefault.default))) throw new (0, _errorsJs.JWEInvalid)("JWE Recipients missing or incorrect type");
    if (!jwe.recipients.length) throw new (0, _errorsJs.JWEInvalid)("JWE Recipients has no members");
    for (const recipient of jwe.recipients)try {
        return await (0, _decryptJs.flattenedDecrypt)({
            aad: jwe.aad,
            ciphertext: jwe.ciphertext,
            encrypted_key: recipient.encrypted_key,
            header: recipient.header,
            iv: jwe.iv,
            protected: jwe.protected,
            tag: jwe.tag,
            unprotected: jwe.unprotected
        }, key, options);
    } catch (_a) {}
    throw new (0, _errorsJs.JWEDecryptionFailed)();
}

},{"../flattened/decrypt.js":"5HUvj","../../util/errors.js":"4fsOp","../../lib/is_object.js":"daSnu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bS3zk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GeneralEncrypt", ()=>GeneralEncrypt);
var _encryptJs = require("../flattened/encrypt.js");
var _errorsJs = require("../../util/errors.js");
var _cekJs = require("../../lib/cek.js");
var _cekJsDefault = parcelHelpers.interopDefault(_cekJs);
var _isDisjointJs = require("../../lib/is_disjoint.js");
var _isDisjointJsDefault = parcelHelpers.interopDefault(_isDisjointJs);
var _encryptKeyManagementJs = require("../../lib/encrypt_key_management.js");
var _encryptKeyManagementJsDefault = parcelHelpers.interopDefault(_encryptKeyManagementJs);
var _base64UrlJs = require("../../runtime/base64url.js");
var _validateCritJs = require("../../lib/validate_crit.js");
var _validateCritJsDefault = parcelHelpers.interopDefault(_validateCritJs);
class IndividualRecipient {
    constructor(enc, key, options){
        this.parent = enc;
        this.key = key;
        this.options = options;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this.unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this.unprotectedHeader = unprotectedHeader;
        return this;
    }
    addRecipient(...args) {
        return this.parent.addRecipient(...args);
    }
    encrypt(...args) {
        return this.parent.encrypt(...args);
    }
    done() {
        return this.parent;
    }
}
class GeneralEncrypt {
    constructor(plaintext){
        this._recipients = [];
        this._plaintext = plaintext;
    }
    addRecipient(key, options) {
        const recipient = new IndividualRecipient(this, key, {
            crit: options === null || options === void 0 ? void 0 : options.crit
        });
        this._recipients.push(recipient);
        return recipient;
    }
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setSharedUnprotectedHeader(sharedUnprotectedHeader) {
        if (this._unprotectedHeader) throw new TypeError("setSharedUnprotectedHeader can only be called once");
        this._unprotectedHeader = sharedUnprotectedHeader;
        return this;
    }
    setAdditionalAuthenticatedData(aad) {
        this._aad = aad;
        return this;
    }
    async encrypt(options) {
        var _a, _b, _c;
        if (!this._recipients.length) throw new (0, _errorsJs.JWEInvalid)("at least one recipient must be added");
        options = {
            deflateRaw: options === null || options === void 0 ? void 0 : options.deflateRaw
        };
        if (this._recipients.length === 1) {
            const [recipient] = this._recipients;
            const flattened = await new (0, _encryptJs.FlattenedEncrypt)(this._plaintext).setAdditionalAuthenticatedData(this._aad).setProtectedHeader(this._protectedHeader).setSharedUnprotectedHeader(this._unprotectedHeader).setUnprotectedHeader(recipient.unprotectedHeader).encrypt(recipient.key, {
                ...recipient.options,
                ...options
            });
            let jwe = {
                ciphertext: flattened.ciphertext,
                iv: flattened.iv,
                recipients: [
                    {}
                ],
                tag: flattened.tag
            };
            if (flattened.aad) jwe.aad = flattened.aad;
            if (flattened.protected) jwe.protected = flattened.protected;
            if (flattened.unprotected) jwe.unprotected = flattened.unprotected;
            if (flattened.encrypted_key) jwe.recipients[0].encrypted_key = flattened.encrypted_key;
            if (flattened.header) jwe.recipients[0].header = flattened.header;
            return jwe;
        }
        let enc;
        for(let i = 0; i < this._recipients.length; i++){
            const recipient = this._recipients[i];
            if (!(0, _isDisjointJsDefault.default)(this._protectedHeader, this._unprotectedHeader, recipient.unprotectedHeader)) throw new (0, _errorsJs.JWEInvalid)("JWE Protected, JWE Shared Unprotected and JWE Per-Recipient Header Parameter names must be disjoint");
            const joseHeader = {
                ...this._protectedHeader,
                ...this._unprotectedHeader,
                ...recipient.unprotectedHeader
            };
            const { alg } = joseHeader;
            if (typeof alg !== "string" || !alg) throw new (0, _errorsJs.JWEInvalid)('JWE "alg" (Algorithm) Header Parameter missing or invalid');
            if (alg === "dir" || alg === "ECDH-ES") throw new (0, _errorsJs.JWEInvalid)('"dir" and "ECDH-ES" alg may only be used with a single recipient');
            if (typeof joseHeader.enc !== "string" || !joseHeader.enc) throw new (0, _errorsJs.JWEInvalid)('JWE "enc" (Encryption Algorithm) Header Parameter missing or invalid');
            if (!enc) enc = joseHeader.enc;
            else if (enc !== joseHeader.enc) throw new (0, _errorsJs.JWEInvalid)('JWE "enc" (Encryption Algorithm) Header Parameter must be the same for all recipients');
            (0, _validateCritJsDefault.default)((0, _errorsJs.JWEInvalid), new Map(), recipient.options.crit, this._protectedHeader, joseHeader);
            if (joseHeader.zip !== undefined) {
                if (!this._protectedHeader || !this._protectedHeader.zip) throw new (0, _errorsJs.JWEInvalid)('JWE "zip" (Compression Algorithm) Header MUST be integrity protected');
            }
        }
        const cek = (0, _cekJsDefault.default)(enc);
        let jwe = {
            ciphertext: "",
            iv: "",
            recipients: [],
            tag: ""
        };
        for(let i = 0; i < this._recipients.length; i++){
            const recipient = this._recipients[i];
            const target = {};
            jwe.recipients.push(target);
            const joseHeader = {
                ...this._protectedHeader,
                ...this._unprotectedHeader,
                ...recipient.unprotectedHeader
            };
            const p2c = joseHeader.alg.startsWith("PBES2") ? 2048 + i : undefined;
            if (i === 0) {
                const flattened = await new (0, _encryptJs.FlattenedEncrypt)(this._plaintext).setAdditionalAuthenticatedData(this._aad).setContentEncryptionKey(cek).setProtectedHeader(this._protectedHeader).setSharedUnprotectedHeader(this._unprotectedHeader).setUnprotectedHeader(recipient.unprotectedHeader).setKeyManagementParameters({
                    p2c
                }).encrypt(recipient.key, {
                    ...recipient.options,
                    ...options,
                    [(0, _encryptJs.unprotected)]: true
                });
                jwe.ciphertext = flattened.ciphertext;
                jwe.iv = flattened.iv;
                jwe.tag = flattened.tag;
                if (flattened.aad) jwe.aad = flattened.aad;
                if (flattened.protected) jwe.protected = flattened.protected;
                if (flattened.unprotected) jwe.unprotected = flattened.unprotected;
                target.encrypted_key = flattened.encrypted_key;
                if (flattened.header) target.header = flattened.header;
                continue;
            }
            const { encryptedKey, parameters } = await (0, _encryptKeyManagementJsDefault.default)(((_a = recipient.unprotectedHeader) === null || _a === void 0 ? void 0 : _a.alg) || ((_b = this._protectedHeader) === null || _b === void 0 ? void 0 : _b.alg) || ((_c = this._unprotectedHeader) === null || _c === void 0 ? void 0 : _c.alg), enc, recipient.key, cek, {
                p2c
            });
            target.encrypted_key = (0, _base64UrlJs.encode)(encryptedKey);
            if (recipient.unprotectedHeader || parameters) target.header = {
                ...recipient.unprotectedHeader,
                ...parameters
            };
        }
        return jwe;
    }
}

},{"../flattened/encrypt.js":"gNmwl","../../util/errors.js":"4fsOp","../../lib/cek.js":"cA5vi","../../lib/is_disjoint.js":"91YXn","../../lib/encrypt_key_management.js":"lMdet","../../runtime/base64url.js":"8Djx4","../../lib/validate_crit.js":"1cFtE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gNmwl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unprotected", ()=>unprotected);
parcelHelpers.export(exports, "FlattenedEncrypt", ()=>FlattenedEncrypt);
var _base64UrlJs = require("../../runtime/base64url.js");
var _encryptJs = require("../../runtime/encrypt.js");
var _encryptJsDefault = parcelHelpers.interopDefault(_encryptJs);
var _zlibJs = require("../../runtime/zlib.js");
var _ivJs = require("../../lib/iv.js");
var _ivJsDefault = parcelHelpers.interopDefault(_ivJs);
var _encryptKeyManagementJs = require("../../lib/encrypt_key_management.js");
var _encryptKeyManagementJsDefault = parcelHelpers.interopDefault(_encryptKeyManagementJs);
var _errorsJs = require("../../util/errors.js");
var _isDisjointJs = require("../../lib/is_disjoint.js");
var _isDisjointJsDefault = parcelHelpers.interopDefault(_isDisjointJs);
var _bufferUtilsJs = require("../../lib/buffer_utils.js");
var _validateCritJs = require("../../lib/validate_crit.js");
var _validateCritJsDefault = parcelHelpers.interopDefault(_validateCritJs);
const unprotected = Symbol();
class FlattenedEncrypt {
    constructor(plaintext){
        if (!(plaintext instanceof Uint8Array)) throw new TypeError("plaintext must be an instance of Uint8Array");
        this._plaintext = plaintext;
    }
    setKeyManagementParameters(parameters) {
        if (this._keyManagementParameters) throw new TypeError("setKeyManagementParameters can only be called once");
        this._keyManagementParameters = parameters;
        return this;
    }
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setSharedUnprotectedHeader(sharedUnprotectedHeader) {
        if (this._sharedUnprotectedHeader) throw new TypeError("setSharedUnprotectedHeader can only be called once");
        this._sharedUnprotectedHeader = sharedUnprotectedHeader;
        return this;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this._unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this._unprotectedHeader = unprotectedHeader;
        return this;
    }
    setAdditionalAuthenticatedData(aad) {
        this._aad = aad;
        return this;
    }
    setContentEncryptionKey(cek) {
        if (this._cek) throw new TypeError("setContentEncryptionKey can only be called once");
        this._cek = cek;
        return this;
    }
    setInitializationVector(iv) {
        if (this._iv) throw new TypeError("setInitializationVector can only be called once");
        this._iv = iv;
        return this;
    }
    async encrypt(key, options) {
        if (!this._protectedHeader && !this._unprotectedHeader && !this._sharedUnprotectedHeader) throw new (0, _errorsJs.JWEInvalid)("either setProtectedHeader, setUnprotectedHeader, or sharedUnprotectedHeader must be called before #encrypt()");
        if (!(0, _isDisjointJsDefault.default)(this._protectedHeader, this._unprotectedHeader, this._sharedUnprotectedHeader)) throw new (0, _errorsJs.JWEInvalid)("JWE Protected, JWE Shared Unprotected and JWE Per-Recipient Header Parameter names must be disjoint");
        const joseHeader = {
            ...this._protectedHeader,
            ...this._unprotectedHeader,
            ...this._sharedUnprotectedHeader
        };
        (0, _validateCritJsDefault.default)((0, _errorsJs.JWEInvalid), new Map(), options === null || options === void 0 ? void 0 : options.crit, this._protectedHeader, joseHeader);
        if (joseHeader.zip !== undefined) {
            if (!this._protectedHeader || !this._protectedHeader.zip) throw new (0, _errorsJs.JWEInvalid)('JWE "zip" (Compression Algorithm) Header MUST be integrity protected');
            if (joseHeader.zip !== "DEF") throw new (0, _errorsJs.JOSENotSupported)('Unsupported JWE "zip" (Compression Algorithm) Header Parameter value');
        }
        const { alg, enc } = joseHeader;
        if (typeof alg !== "string" || !alg) throw new (0, _errorsJs.JWEInvalid)('JWE "alg" (Algorithm) Header Parameter missing or invalid');
        if (typeof enc !== "string" || !enc) throw new (0, _errorsJs.JWEInvalid)('JWE "enc" (Encryption Algorithm) Header Parameter missing or invalid');
        let encryptedKey;
        if (alg === "dir") {
            if (this._cek) throw new TypeError("setContentEncryptionKey cannot be called when using Direct Encryption");
        } else if (alg === "ECDH-ES") {
            if (this._cek) throw new TypeError("setContentEncryptionKey cannot be called when using Direct Key Agreement");
        }
        let cek;
        {
            let parameters;
            ({ cek, encryptedKey, parameters } = await (0, _encryptKeyManagementJsDefault.default)(alg, enc, key, this._cek, this._keyManagementParameters));
            if (parameters) {
                if (options && unprotected in options) {
                    if (!this._unprotectedHeader) this.setUnprotectedHeader(parameters);
                    else this._unprotectedHeader = {
                        ...this._unprotectedHeader,
                        ...parameters
                    };
                } else if (!this._protectedHeader) this.setProtectedHeader(parameters);
                else this._protectedHeader = {
                    ...this._protectedHeader,
                    ...parameters
                };
            }
        }
        this._iv || (this._iv = (0, _ivJsDefault.default)(enc));
        let additionalData;
        let protectedHeader;
        let aadMember;
        if (this._protectedHeader) protectedHeader = (0, _bufferUtilsJs.encoder).encode((0, _base64UrlJs.encode)(JSON.stringify(this._protectedHeader)));
        else protectedHeader = (0, _bufferUtilsJs.encoder).encode("");
        if (this._aad) {
            aadMember = (0, _base64UrlJs.encode)(this._aad);
            additionalData = (0, _bufferUtilsJs.concat)(protectedHeader, (0, _bufferUtilsJs.encoder).encode("."), (0, _bufferUtilsJs.encoder).encode(aadMember));
        } else additionalData = protectedHeader;
        let ciphertext;
        let tag;
        if (joseHeader.zip === "DEF") {
            const deflated = await ((options === null || options === void 0 ? void 0 : options.deflateRaw) || (0, _zlibJs.deflate))(this._plaintext);
            ({ ciphertext, tag } = await (0, _encryptJsDefault.default)(enc, deflated, cek, this._iv, additionalData));
        } else ({ ciphertext, tag } = await (0, _encryptJsDefault.default)(enc, this._plaintext, cek, this._iv, additionalData));
        const jwe = {
            ciphertext: (0, _base64UrlJs.encode)(ciphertext),
            iv: (0, _base64UrlJs.encode)(this._iv),
            tag: (0, _base64UrlJs.encode)(tag)
        };
        if (encryptedKey) jwe.encrypted_key = (0, _base64UrlJs.encode)(encryptedKey);
        if (aadMember) jwe.aad = aadMember;
        if (this._protectedHeader) jwe.protected = (0, _bufferUtilsJs.decoder).decode(protectedHeader);
        if (this._sharedUnprotectedHeader) jwe.unprotected = this._sharedUnprotectedHeader;
        if (this._unprotectedHeader) jwe.header = this._unprotectedHeader;
        return jwe;
    }
}

},{"../../runtime/base64url.js":"8Djx4","../../runtime/encrypt.js":"lfNrn","../../runtime/zlib.js":"dM1d1","../../lib/iv.js":"bvMJc","../../lib/encrypt_key_management.js":"lMdet","../../util/errors.js":"4fsOp","../../lib/is_disjoint.js":"91YXn","../../lib/buffer_utils.js":"h0x9u","../../lib/validate_crit.js":"1cFtE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lMdet":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _aeskwJs = require("../runtime/aeskw.js");
var _ecdhesJs = require("../runtime/ecdhes.js");
var _pbes2KwJs = require("../runtime/pbes2kw.js");
var _rsaesJs = require("../runtime/rsaes.js");
var _base64UrlJs = require("../runtime/base64url.js");
var _cekJs = require("../lib/cek.js");
var _cekJsDefault = parcelHelpers.interopDefault(_cekJs);
var _errorsJs = require("../util/errors.js");
var _exportJs = require("../key/export.js");
var _checkKeyTypeJs = require("./check_key_type.js");
var _checkKeyTypeJsDefault = parcelHelpers.interopDefault(_checkKeyTypeJs);
var _aesgcmkwJs = require("./aesgcmkw.js");
async function encryptKeyManagement(alg, enc, key, providedCek, providedParameters = {}) {
    let encryptedKey;
    let parameters;
    let cek;
    (0, _checkKeyTypeJsDefault.default)(alg, key, "encrypt");
    switch(alg){
        case "dir":
            cek = key;
            break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                if (!_ecdhesJs.ecdhAllowed(key)) throw new (0, _errorsJs.JOSENotSupported)("ECDH with the provided key is not allowed or not supported by your javascript runtime");
                const { apu, apv } = providedParameters;
                let { epk: ephemeralKey } = providedParameters;
                ephemeralKey || (ephemeralKey = (await _ecdhesJs.generateEpk(key)).privateKey);
                const { x, y, crv, kty } = await (0, _exportJs.exportJWK)(ephemeralKey);
                const sharedSecret = await _ecdhesJs.deriveKey(key, ephemeralKey, alg === "ECDH-ES" ? enc : alg, alg === "ECDH-ES" ? (0, _cekJs.bitLength)(enc) : parseInt(alg.slice(-5, -2), 10), apu, apv);
                parameters = {
                    epk: {
                        x,
                        crv,
                        kty
                    }
                };
                if (kty === "EC") parameters.epk.y = y;
                if (apu) parameters.apu = (0, _base64UrlJs.encode)(apu);
                if (apv) parameters.apv = (0, _base64UrlJs.encode)(apv);
                if (alg === "ECDH-ES") {
                    cek = sharedSecret;
                    break;
                }
                cek = providedCek || (0, _cekJsDefault.default)(enc);
                const kwAlg = alg.slice(-6);
                encryptedKey = await (0, _aeskwJs.wrap)(kwAlg, sharedSecret, cek);
                break;
            }
        case "RSA1_5":
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            cek = providedCek || (0, _cekJsDefault.default)(enc);
            encryptedKey = await (0, _rsaesJs.encrypt)(alg, key, cek);
            break;
        case "PBES2-HS256+A128KW":
        case "PBES2-HS384+A192KW":
        case "PBES2-HS512+A256KW":
            {
                cek = providedCek || (0, _cekJsDefault.default)(enc);
                const { p2c, p2s } = providedParameters;
                ({ encryptedKey, ...parameters } = await (0, _pbes2KwJs.encrypt)(alg, key, cek, p2c, p2s));
                break;
            }
        case "A128KW":
        case "A192KW":
        case "A256KW":
            cek = providedCek || (0, _cekJsDefault.default)(enc);
            encryptedKey = await (0, _aeskwJs.wrap)(alg, key, cek);
            break;
        case "A128GCMKW":
        case "A192GCMKW":
        case "A256GCMKW":
            {
                cek = providedCek || (0, _cekJsDefault.default)(enc);
                const { iv } = providedParameters;
                ({ encryptedKey, ...parameters } = await (0, _aesgcmkwJs.wrap)(alg, key, cek, iv));
                break;
            }
        default:
            throw new (0, _errorsJs.JOSENotSupported)('Invalid or unsupported "alg" (JWE Algorithm) header value');
    }
    return {
        cek,
        encryptedKey,
        parameters
    };
}
exports.default = encryptKeyManagement;

},{"../runtime/aeskw.js":"2J708","../runtime/ecdhes.js":"74mdv","../runtime/pbes2kw.js":"43KtE","../runtime/rsaes.js":"3mFhj","../runtime/base64url.js":"8Djx4","../lib/cek.js":"cA5vi","../util/errors.js":"4fsOp","../key/export.js":"1EYA6","./check_key_type.js":"5ompv","./aesgcmkw.js":"6zfNV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1EYA6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "exportSPKI", ()=>exportSPKI);
parcelHelpers.export(exports, "exportPKCS8", ()=>exportPKCS8);
parcelHelpers.export(exports, "exportJWK", ()=>exportJWK);
var _asn1Js = require("../runtime/asn1.js");
var _keyToJwkJs = require("../runtime/key_to_jwk.js");
var _keyToJwkJsDefault = parcelHelpers.interopDefault(_keyToJwkJs);
async function exportSPKI(key) {
    return (0, _asn1Js.toSPKI)(key);
}
async function exportPKCS8(key) {
    return (0, _asn1Js.toPKCS8)(key);
}
async function exportJWK(key) {
    return (0, _keyToJwkJsDefault.default)(key);
}

},{"../runtime/asn1.js":"CWUVr","../runtime/key_to_jwk.js":"hWtcO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hWtcO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _webcryptoJs = require("./webcrypto.js");
var _webcryptoJsDefault = parcelHelpers.interopDefault(_webcryptoJs);
var _invalidKeyInputJs = require("../lib/invalid_key_input.js");
var _invalidKeyInputJsDefault = parcelHelpers.interopDefault(_invalidKeyInputJs);
var _base64UrlJs = require("./base64url.js");
var _isKeyLikeJs = require("./is_key_like.js");
const keyToJWK = async (key)=>{
    if (key instanceof Uint8Array) return {
        kty: "oct",
        k: (0, _base64UrlJs.encode)(key)
    };
    if (!(0, _webcryptoJs.isCryptoKey)(key)) throw new TypeError((0, _invalidKeyInputJsDefault.default)(key, ...(0, _isKeyLikeJs.types), "Uint8Array"));
    if (!key.extractable) throw new TypeError("non-extractable CryptoKey cannot be exported as a JWK");
    const { ext, key_ops, alg, use, ...jwk } = await (0, _webcryptoJsDefault.default).subtle.exportKey("jwk", key);
    return jwk;
};
exports.default = keyToJWK;

},{"./webcrypto.js":"aUHBb","../lib/invalid_key_input.js":"5GTGb","./base64url.js":"8Djx4","./is_key_like.js":"9kDjz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dFemI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "compactVerify", ()=>compactVerify);
var _verifyJs = require("../flattened/verify.js");
var _errorsJs = require("../../util/errors.js");
var _bufferUtilsJs = require("../../lib/buffer_utils.js");
async function compactVerify(jws, key, options) {
    if (jws instanceof Uint8Array) jws = (0, _bufferUtilsJs.decoder).decode(jws);
    if (typeof jws !== "string") throw new (0, _errorsJs.JWSInvalid)("Compact JWS must be a string or Uint8Array");
    const { 0: protectedHeader, 1: payload, 2: signature, length } = jws.split(".");
    if (length !== 3) throw new (0, _errorsJs.JWSInvalid)("Invalid Compact JWS");
    const verified = await (0, _verifyJs.flattenedVerify)({
        payload,
        protected: protectedHeader,
        signature
    }, key, options);
    const result = {
        payload: verified.payload,
        protectedHeader: verified.protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: verified.key
    };
    return result;
}

},{"../flattened/verify.js":"2EX3K","../../util/errors.js":"4fsOp","../../lib/buffer_utils.js":"h0x9u","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2EX3K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "flattenedVerify", ()=>flattenedVerify);
var _base64UrlJs = require("../../runtime/base64url.js");
var _verifyJs = require("../../runtime/verify.js");
var _verifyJsDefault = parcelHelpers.interopDefault(_verifyJs);
var _errorsJs = require("../../util/errors.js");
var _bufferUtilsJs = require("../../lib/buffer_utils.js");
var _isDisjointJs = require("../../lib/is_disjoint.js");
var _isDisjointJsDefault = parcelHelpers.interopDefault(_isDisjointJs);
var _isObjectJs = require("../../lib/is_object.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _checkKeyTypeJs = require("../../lib/check_key_type.js");
var _checkKeyTypeJsDefault = parcelHelpers.interopDefault(_checkKeyTypeJs);
var _validateCritJs = require("../../lib/validate_crit.js");
var _validateCritJsDefault = parcelHelpers.interopDefault(_validateCritJs);
var _validateAlgorithmsJs = require("../../lib/validate_algorithms.js");
var _validateAlgorithmsJsDefault = parcelHelpers.interopDefault(_validateAlgorithmsJs);
async function flattenedVerify(jws, key, options) {
    var _a;
    if (!(0, _isObjectJsDefault.default)(jws)) throw new (0, _errorsJs.JWSInvalid)("Flattened JWS must be an object");
    if (jws.protected === undefined && jws.header === undefined) throw new (0, _errorsJs.JWSInvalid)('Flattened JWS must have either of the "protected" or "header" members');
    if (jws.protected !== undefined && typeof jws.protected !== "string") throw new (0, _errorsJs.JWSInvalid)("JWS Protected Header incorrect type");
    if (jws.payload === undefined) throw new (0, _errorsJs.JWSInvalid)("JWS Payload missing");
    if (typeof jws.signature !== "string") throw new (0, _errorsJs.JWSInvalid)("JWS Signature missing or incorrect type");
    if (jws.header !== undefined && !(0, _isObjectJsDefault.default)(jws.header)) throw new (0, _errorsJs.JWSInvalid)("JWS Unprotected Header incorrect type");
    let parsedProt = {};
    if (jws.protected) try {
        const protectedHeader = (0, _base64UrlJs.decode)(jws.protected);
        parsedProt = JSON.parse((0, _bufferUtilsJs.decoder).decode(protectedHeader));
    } catch (_b) {
        throw new (0, _errorsJs.JWSInvalid)("JWS Protected Header is invalid");
    }
    if (!(0, _isDisjointJsDefault.default)(parsedProt, jws.header)) throw new (0, _errorsJs.JWSInvalid)("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
    const joseHeader = {
        ...parsedProt,
        ...jws.header
    };
    const extensions = (0, _validateCritJsDefault.default)((0, _errorsJs.JWSInvalid), new Map([
        [
            "b64",
            true
        ]
    ]), options === null || options === void 0 ? void 0 : options.crit, parsedProt, joseHeader);
    let b64 = true;
    if (extensions.has("b64")) {
        b64 = parsedProt.b64;
        if (typeof b64 !== "boolean") throw new (0, _errorsJs.JWSInvalid)('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
    }
    const { alg } = joseHeader;
    if (typeof alg !== "string" || !alg) throw new (0, _errorsJs.JWSInvalid)('JWS "alg" (Algorithm) Header Parameter missing or invalid');
    const algorithms = options && (0, _validateAlgorithmsJsDefault.default)("algorithms", options.algorithms);
    if (algorithms && !algorithms.has(alg)) throw new (0, _errorsJs.JOSEAlgNotAllowed)('"alg" (Algorithm) Header Parameter not allowed');
    if (b64) {
        if (typeof jws.payload !== "string") throw new (0, _errorsJs.JWSInvalid)("JWS Payload must be a string");
    } else if (typeof jws.payload !== "string" && !(jws.payload instanceof Uint8Array)) throw new (0, _errorsJs.JWSInvalid)("JWS Payload must be a string or an Uint8Array instance");
    let resolvedKey = false;
    if (typeof key === "function") {
        key = await key(parsedProt, jws);
        resolvedKey = true;
    }
    (0, _checkKeyTypeJsDefault.default)(alg, key, "verify");
    const data = (0, _bufferUtilsJs.concat)((0, _bufferUtilsJs.encoder).encode((_a = jws.protected) !== null && _a !== void 0 ? _a : ""), (0, _bufferUtilsJs.encoder).encode("."), typeof jws.payload === "string" ? (0, _bufferUtilsJs.encoder).encode(jws.payload) : jws.payload);
    let signature;
    try {
        signature = (0, _base64UrlJs.decode)(jws.signature);
    } catch (_c) {
        throw new (0, _errorsJs.JWSInvalid)("Failed to base64url decode the signature");
    }
    const verified = await (0, _verifyJsDefault.default)(alg, key, signature, data);
    if (!verified) throw new (0, _errorsJs.JWSSignatureVerificationFailed)();
    let payload;
    if (b64) try {
        payload = (0, _base64UrlJs.decode)(jws.payload);
    } catch (_d) {
        throw new (0, _errorsJs.JWSInvalid)("Failed to base64url decode the payload");
    }
    else if (typeof jws.payload === "string") payload = (0, _bufferUtilsJs.encoder).encode(jws.payload);
    else payload = jws.payload;
    const result = {
        payload
    };
    if (jws.protected !== undefined) result.protectedHeader = parsedProt;
    if (jws.header !== undefined) result.unprotectedHeader = jws.header;
    if (resolvedKey) return {
        ...result,
        key
    };
    return result;
}

},{"../../runtime/base64url.js":"8Djx4","../../runtime/verify.js":"dznWE","../../util/errors.js":"4fsOp","../../lib/buffer_utils.js":"h0x9u","../../lib/is_disjoint.js":"91YXn","../../lib/is_object.js":"daSnu","../../lib/check_key_type.js":"5ompv","../../lib/validate_crit.js":"1cFtE","../../lib/validate_algorithms.js":"fDDwK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dznWE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _subtleDsaJs = require("./subtle_dsa.js");
var _subtleDsaJsDefault = parcelHelpers.interopDefault(_subtleDsaJs);
var _webcryptoJs = require("./webcrypto.js");
var _webcryptoJsDefault = parcelHelpers.interopDefault(_webcryptoJs);
var _checkKeyLengthJs = require("./check_key_length.js");
var _checkKeyLengthJsDefault = parcelHelpers.interopDefault(_checkKeyLengthJs);
var _getSignVerifyKeyJs = require("./get_sign_verify_key.js");
var _getSignVerifyKeyJsDefault = parcelHelpers.interopDefault(_getSignVerifyKeyJs);
const verify = async (alg, key, signature, data)=>{
    const cryptoKey = await (0, _getSignVerifyKeyJsDefault.default)(alg, key, "verify");
    (0, _checkKeyLengthJsDefault.default)(alg, cryptoKey);
    const algorithm = (0, _subtleDsaJsDefault.default)(alg, cryptoKey.algorithm);
    try {
        return await (0, _webcryptoJsDefault.default).subtle.verify(algorithm, cryptoKey, signature, data);
    } catch (_a) {
        return false;
    }
};
exports.default = verify;

},{"./subtle_dsa.js":"92soc","./webcrypto.js":"aUHBb","./check_key_length.js":"0CfW9","./get_sign_verify_key.js":"pIGMc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"92soc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subtleDsa);
var _errorsJs = require("../util/errors.js");
function subtleDsa(alg, algorithm) {
    const hash = `SHA-${alg.slice(-3)}`;
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            return {
                hash,
                name: "HMAC"
            };
        case "PS256":
        case "PS384":
        case "PS512":
            return {
                hash,
                name: "RSA-PSS",
                saltLength: alg.slice(-3) >> 3
            };
        case "RS256":
        case "RS384":
        case "RS512":
            return {
                hash,
                name: "RSASSA-PKCS1-v1_5"
            };
        case "ES256":
        case "ES384":
        case "ES512":
            return {
                hash,
                name: "ECDSA",
                namedCurve: algorithm.namedCurve
            };
        case "EdDSA":
            return {
                name: algorithm.name
            };
        default:
            throw new (0, _errorsJs.JOSENotSupported)(`alg ${alg} is not supported either by JOSE or your javascript runtime`);
    }
}

},{"../util/errors.js":"4fsOp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"pIGMc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getCryptoKey);
var _webcryptoJs = require("./webcrypto.js");
var _webcryptoJsDefault = parcelHelpers.interopDefault(_webcryptoJs);
var _cryptoKeyJs = require("../lib/crypto_key.js");
var _invalidKeyInputJs = require("../lib/invalid_key_input.js");
var _invalidKeyInputJsDefault = parcelHelpers.interopDefault(_invalidKeyInputJs);
var _isKeyLikeJs = require("./is_key_like.js");
function getCryptoKey(alg, key, usage) {
    if ((0, _webcryptoJs.isCryptoKey)(key)) {
        (0, _cryptoKeyJs.checkSigCryptoKey)(key, alg, usage);
        return key;
    }
    if (key instanceof Uint8Array) {
        if (!alg.startsWith("HS")) throw new TypeError((0, _invalidKeyInputJsDefault.default)(key, ...(0, _isKeyLikeJs.types)));
        return (0, _webcryptoJsDefault.default).subtle.importKey("raw", key, {
            hash: `SHA-${alg.slice(-3)}`,
            name: "HMAC"
        }, false, [
            usage
        ]);
    }
    throw new TypeError((0, _invalidKeyInputJsDefault.default)(key, ...(0, _isKeyLikeJs.types), "Uint8Array"));
}

},{"./webcrypto.js":"aUHBb","../lib/crypto_key.js":"gM0cz","../lib/invalid_key_input.js":"5GTGb","./is_key_like.js":"9kDjz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f4rEE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generalVerify", ()=>generalVerify);
var _verifyJs = require("../flattened/verify.js");
var _errorsJs = require("../../util/errors.js");
var _isObjectJs = require("../../lib/is_object.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
async function generalVerify(jws, key, options) {
    if (!(0, _isObjectJsDefault.default)(jws)) throw new (0, _errorsJs.JWSInvalid)("General JWS must be an object");
    if (!Array.isArray(jws.signatures) || !jws.signatures.every((0, _isObjectJsDefault.default))) throw new (0, _errorsJs.JWSInvalid)("JWS Signatures missing or incorrect type");
    for (const signature of jws.signatures)try {
        return await (0, _verifyJs.flattenedVerify)({
            header: signature.header,
            payload: jws.payload,
            protected: signature.protected,
            signature: signature.signature
        }, key, options);
    } catch (_a) {}
    throw new (0, _errorsJs.JWSSignatureVerificationFailed)();
}

},{"../flattened/verify.js":"2EX3K","../../util/errors.js":"4fsOp","../../lib/is_object.js":"daSnu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9uAkr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "jwtVerify", ()=>jwtVerify);
var _verifyJs = require("../jws/compact/verify.js");
var _jwtClaimsSetJs = require("../lib/jwt_claims_set.js");
var _jwtClaimsSetJsDefault = parcelHelpers.interopDefault(_jwtClaimsSetJs);
var _errorsJs = require("../util/errors.js");
async function jwtVerify(jwt, key, options) {
    var _a;
    const verified = await (0, _verifyJs.compactVerify)(jwt, key, options);
    if (((_a = verified.protectedHeader.crit) === null || _a === void 0 ? void 0 : _a.includes("b64")) && verified.protectedHeader.b64 === false) throw new (0, _errorsJs.JWTInvalid)("JWTs MUST NOT use unencoded payload");
    const payload = (0, _jwtClaimsSetJsDefault.default)(verified.protectedHeader, verified.payload, options);
    const result = {
        payload,
        protectedHeader: verified.protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: verified.key
    };
    return result;
}

},{"../jws/compact/verify.js":"dFemI","../lib/jwt_claims_set.js":"eRU3a","../util/errors.js":"4fsOp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eRU3a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _errorsJs = require("../util/errors.js");
var _bufferUtilsJs = require("./buffer_utils.js");
var _epochJs = require("./epoch.js");
var _epochJsDefault = parcelHelpers.interopDefault(_epochJs);
var _secsJs = require("./secs.js");
var _secsJsDefault = parcelHelpers.interopDefault(_secsJs);
var _isObjectJs = require("./is_object.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
const normalizeTyp = (value)=>value.toLowerCase().replace(/^application\//, "");
const checkAudiencePresence = (audPayload, audOption)=>{
    if (typeof audPayload === "string") return audOption.includes(audPayload);
    if (Array.isArray(audPayload)) return audOption.some(Set.prototype.has.bind(new Set(audPayload)));
    return false;
};
exports.default = (protectedHeader, encodedPayload, options = {})=>{
    const { typ } = options;
    if (typ && (typeof protectedHeader.typ !== "string" || normalizeTyp(protectedHeader.typ) !== normalizeTyp(typ))) throw new (0, _errorsJs.JWTClaimValidationFailed)('unexpected "typ" JWT header value', "typ", "check_failed");
    let payload;
    try {
        payload = JSON.parse((0, _bufferUtilsJs.decoder).decode(encodedPayload));
    } catch (_a) {}
    if (!(0, _isObjectJsDefault.default)(payload)) throw new (0, _errorsJs.JWTInvalid)("JWT Claims Set must be a top-level JSON object");
    const { requiredClaims = [], issuer, subject, audience, maxTokenAge } = options;
    if (maxTokenAge !== undefined) requiredClaims.push("iat");
    if (audience !== undefined) requiredClaims.push("aud");
    if (subject !== undefined) requiredClaims.push("sub");
    if (issuer !== undefined) requiredClaims.push("iss");
    for (const claim of new Set(requiredClaims.reverse())){
        if (!(claim in payload)) throw new (0, _errorsJs.JWTClaimValidationFailed)(`missing required "${claim}" claim`, claim, "missing");
    }
    if (issuer && !(Array.isArray(issuer) ? issuer : [
        issuer
    ]).includes(payload.iss)) throw new (0, _errorsJs.JWTClaimValidationFailed)('unexpected "iss" claim value', "iss", "check_failed");
    if (subject && payload.sub !== subject) throw new (0, _errorsJs.JWTClaimValidationFailed)('unexpected "sub" claim value', "sub", "check_failed");
    if (audience && !checkAudiencePresence(payload.aud, typeof audience === "string" ? [
        audience
    ] : audience)) throw new (0, _errorsJs.JWTClaimValidationFailed)('unexpected "aud" claim value', "aud", "check_failed");
    let tolerance;
    switch(typeof options.clockTolerance){
        case "string":
            tolerance = (0, _secsJsDefault.default)(options.clockTolerance);
            break;
        case "number":
            tolerance = options.clockTolerance;
            break;
        case "undefined":
            tolerance = 0;
            break;
        default:
            throw new TypeError("Invalid clockTolerance option type");
    }
    const { currentDate } = options;
    const now = (0, _epochJsDefault.default)(currentDate || new Date());
    if ((payload.iat !== undefined || maxTokenAge) && typeof payload.iat !== "number") throw new (0, _errorsJs.JWTClaimValidationFailed)('"iat" claim must be a number', "iat", "invalid");
    if (payload.nbf !== undefined) {
        if (typeof payload.nbf !== "number") throw new (0, _errorsJs.JWTClaimValidationFailed)('"nbf" claim must be a number', "nbf", "invalid");
        if (payload.nbf > now + tolerance) throw new (0, _errorsJs.JWTClaimValidationFailed)('"nbf" claim timestamp check failed', "nbf", "check_failed");
    }
    if (payload.exp !== undefined) {
        if (typeof payload.exp !== "number") throw new (0, _errorsJs.JWTClaimValidationFailed)('"exp" claim must be a number', "exp", "invalid");
        if (payload.exp <= now - tolerance) throw new (0, _errorsJs.JWTExpired)('"exp" claim timestamp check failed', "exp", "check_failed");
    }
    if (maxTokenAge) {
        const age = now - payload.iat;
        const max = typeof maxTokenAge === "number" ? maxTokenAge : (0, _secsJsDefault.default)(maxTokenAge);
        if (age - tolerance > max) throw new (0, _errorsJs.JWTExpired)('"iat" claim timestamp check failed (too far in the past)', "iat", "check_failed");
        if (age < 0 - tolerance) throw new (0, _errorsJs.JWTClaimValidationFailed)('"iat" claim timestamp check failed (it should be in the past)', "iat", "check_failed");
    }
    return payload;
};

},{"../util/errors.js":"4fsOp","./buffer_utils.js":"h0x9u","./epoch.js":"htxcB","./secs.js":"55mqE","./is_object.js":"daSnu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"htxcB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (date)=>Math.floor(date.getTime() / 1000);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"55mqE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const minute = 60;
const hour = minute * 60;
const day = hour * 24;
const week = day * 7;
const year = day * 365.25;
const REGEX = /^(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)$/i;
exports.default = (str)=>{
    const matched = REGEX.exec(str);
    if (!matched) throw new TypeError("Invalid time period format");
    const value = parseFloat(matched[1]);
    const unit = matched[2].toLowerCase();
    switch(unit){
        case "sec":
        case "secs":
        case "second":
        case "seconds":
        case "s":
            return Math.round(value);
        case "minute":
        case "minutes":
        case "min":
        case "mins":
        case "m":
            return Math.round(value * minute);
        case "hour":
        case "hours":
        case "hr":
        case "hrs":
        case "h":
            return Math.round(value * hour);
        case "day":
        case "days":
        case "d":
            return Math.round(value * day);
        case "week":
        case "weeks":
        case "w":
            return Math.round(value * week);
        default:
            return Math.round(value * year);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lrzVM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "jwtDecrypt", ()=>jwtDecrypt);
var _decryptJs = require("../jwe/compact/decrypt.js");
var _jwtClaimsSetJs = require("../lib/jwt_claims_set.js");
var _jwtClaimsSetJsDefault = parcelHelpers.interopDefault(_jwtClaimsSetJs);
var _errorsJs = require("../util/errors.js");
async function jwtDecrypt(jwt, key, options) {
    const decrypted = await (0, _decryptJs.compactDecrypt)(jwt, key, options);
    const payload = (0, _jwtClaimsSetJsDefault.default)(decrypted.protectedHeader, decrypted.plaintext, options);
    const { protectedHeader } = decrypted;
    if (protectedHeader.iss !== undefined && protectedHeader.iss !== payload.iss) throw new (0, _errorsJs.JWTClaimValidationFailed)('replicated "iss" claim header parameter mismatch', "iss", "mismatch");
    if (protectedHeader.sub !== undefined && protectedHeader.sub !== payload.sub) throw new (0, _errorsJs.JWTClaimValidationFailed)('replicated "sub" claim header parameter mismatch', "sub", "mismatch");
    if (protectedHeader.aud !== undefined && JSON.stringify(protectedHeader.aud) !== JSON.stringify(payload.aud)) throw new (0, _errorsJs.JWTClaimValidationFailed)('replicated "aud" claim header parameter mismatch', "aud", "mismatch");
    const result = {
        payload,
        protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: decrypted.key
    };
    return result;
}

},{"../jwe/compact/decrypt.js":"e85ol","../lib/jwt_claims_set.js":"eRU3a","../util/errors.js":"4fsOp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Mv4N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CompactEncrypt", ()=>CompactEncrypt);
var _encryptJs = require("../flattened/encrypt.js");
class CompactEncrypt {
    constructor(plaintext){
        this._flattened = new (0, _encryptJs.FlattenedEncrypt)(plaintext);
    }
    setContentEncryptionKey(cek) {
        this._flattened.setContentEncryptionKey(cek);
        return this;
    }
    setInitializationVector(iv) {
        this._flattened.setInitializationVector(iv);
        return this;
    }
    setProtectedHeader(protectedHeader) {
        this._flattened.setProtectedHeader(protectedHeader);
        return this;
    }
    setKeyManagementParameters(parameters) {
        this._flattened.setKeyManagementParameters(parameters);
        return this;
    }
    async encrypt(key, options) {
        const jwe = await this._flattened.encrypt(key, options);
        return [
            jwe.protected,
            jwe.encrypted_key,
            jwe.iv,
            jwe.ciphertext,
            jwe.tag
        ].join(".");
    }
}

},{"../flattened/encrypt.js":"gNmwl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4n4CU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CompactSign", ()=>CompactSign);
var _signJs = require("../flattened/sign.js");
class CompactSign {
    constructor(payload){
        this._flattened = new (0, _signJs.FlattenedSign)(payload);
    }
    setProtectedHeader(protectedHeader) {
        this._flattened.setProtectedHeader(protectedHeader);
        return this;
    }
    async sign(key, options) {
        const jws = await this._flattened.sign(key, options);
        if (jws.payload === undefined) throw new TypeError("use the flattened module for creating JWS with b64: false");
        return `${jws.protected}.${jws.payload}.${jws.signature}`;
    }
}

},{"../flattened/sign.js":"lqvdz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lqvdz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FlattenedSign", ()=>FlattenedSign);
var _base64UrlJs = require("../../runtime/base64url.js");
var _signJs = require("../../runtime/sign.js");
var _signJsDefault = parcelHelpers.interopDefault(_signJs);
var _isDisjointJs = require("../../lib/is_disjoint.js");
var _isDisjointJsDefault = parcelHelpers.interopDefault(_isDisjointJs);
var _errorsJs = require("../../util/errors.js");
var _bufferUtilsJs = require("../../lib/buffer_utils.js");
var _checkKeyTypeJs = require("../../lib/check_key_type.js");
var _checkKeyTypeJsDefault = parcelHelpers.interopDefault(_checkKeyTypeJs);
var _validateCritJs = require("../../lib/validate_crit.js");
var _validateCritJsDefault = parcelHelpers.interopDefault(_validateCritJs);
class FlattenedSign {
    constructor(payload){
        if (!(payload instanceof Uint8Array)) throw new TypeError("payload must be an instance of Uint8Array");
        this._payload = payload;
    }
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this._unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this._unprotectedHeader = unprotectedHeader;
        return this;
    }
    async sign(key, options) {
        if (!this._protectedHeader && !this._unprotectedHeader) throw new (0, _errorsJs.JWSInvalid)("either setProtectedHeader or setUnprotectedHeader must be called before #sign()");
        if (!(0, _isDisjointJsDefault.default)(this._protectedHeader, this._unprotectedHeader)) throw new (0, _errorsJs.JWSInvalid)("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
        const joseHeader = {
            ...this._protectedHeader,
            ...this._unprotectedHeader
        };
        const extensions = (0, _validateCritJsDefault.default)((0, _errorsJs.JWSInvalid), new Map([
            [
                "b64",
                true
            ]
        ]), options === null || options === void 0 ? void 0 : options.crit, this._protectedHeader, joseHeader);
        let b64 = true;
        if (extensions.has("b64")) {
            b64 = this._protectedHeader.b64;
            if (typeof b64 !== "boolean") throw new (0, _errorsJs.JWSInvalid)('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
        }
        const { alg } = joseHeader;
        if (typeof alg !== "string" || !alg) throw new (0, _errorsJs.JWSInvalid)('JWS "alg" (Algorithm) Header Parameter missing or invalid');
        (0, _checkKeyTypeJsDefault.default)(alg, key, "sign");
        let payload = this._payload;
        if (b64) payload = (0, _bufferUtilsJs.encoder).encode((0, _base64UrlJs.encode)(payload));
        let protectedHeader;
        if (this._protectedHeader) protectedHeader = (0, _bufferUtilsJs.encoder).encode((0, _base64UrlJs.encode)(JSON.stringify(this._protectedHeader)));
        else protectedHeader = (0, _bufferUtilsJs.encoder).encode("");
        const data = (0, _bufferUtilsJs.concat)(protectedHeader, (0, _bufferUtilsJs.encoder).encode("."), payload);
        const signature = await (0, _signJsDefault.default)(alg, key, data);
        const jws = {
            signature: (0, _base64UrlJs.encode)(signature),
            payload: ""
        };
        if (b64) jws.payload = (0, _bufferUtilsJs.decoder).decode(payload);
        if (this._unprotectedHeader) jws.header = this._unprotectedHeader;
        if (this._protectedHeader) jws.protected = (0, _bufferUtilsJs.decoder).decode(protectedHeader);
        return jws;
    }
}

},{"../../runtime/base64url.js":"8Djx4","../../runtime/sign.js":"3bvVs","../../lib/is_disjoint.js":"91YXn","../../util/errors.js":"4fsOp","../../lib/buffer_utils.js":"h0x9u","../../lib/check_key_type.js":"5ompv","../../lib/validate_crit.js":"1cFtE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3bvVs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _subtleDsaJs = require("./subtle_dsa.js");
var _subtleDsaJsDefault = parcelHelpers.interopDefault(_subtleDsaJs);
var _webcryptoJs = require("./webcrypto.js");
var _webcryptoJsDefault = parcelHelpers.interopDefault(_webcryptoJs);
var _checkKeyLengthJs = require("./check_key_length.js");
var _checkKeyLengthJsDefault = parcelHelpers.interopDefault(_checkKeyLengthJs);
var _getSignVerifyKeyJs = require("./get_sign_verify_key.js");
var _getSignVerifyKeyJsDefault = parcelHelpers.interopDefault(_getSignVerifyKeyJs);
const sign = async (alg, key, data)=>{
    const cryptoKey = await (0, _getSignVerifyKeyJsDefault.default)(alg, key, "sign");
    (0, _checkKeyLengthJsDefault.default)(alg, cryptoKey);
    const signature = await (0, _webcryptoJsDefault.default).subtle.sign((0, _subtleDsaJsDefault.default)(alg, cryptoKey.algorithm), cryptoKey, data);
    return new Uint8Array(signature);
};
exports.default = sign;

},{"./subtle_dsa.js":"92soc","./webcrypto.js":"aUHBb","./check_key_length.js":"0CfW9","./get_sign_verify_key.js":"pIGMc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"chvqI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GeneralSign", ()=>GeneralSign);
var _signJs = require("../flattened/sign.js");
var _errorsJs = require("../../util/errors.js");
class IndividualSignature {
    constructor(sig, key, options){
        this.parent = sig;
        this.key = key;
        this.options = options;
    }
    setProtectedHeader(protectedHeader) {
        if (this.protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this.protectedHeader = protectedHeader;
        return this;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this.unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this.unprotectedHeader = unprotectedHeader;
        return this;
    }
    addSignature(...args) {
        return this.parent.addSignature(...args);
    }
    sign(...args) {
        return this.parent.sign(...args);
    }
    done() {
        return this.parent;
    }
}
class GeneralSign {
    constructor(payload){
        this._signatures = [];
        this._payload = payload;
    }
    addSignature(key, options) {
        const signature = new IndividualSignature(this, key, options);
        this._signatures.push(signature);
        return signature;
    }
    async sign() {
        if (!this._signatures.length) throw new (0, _errorsJs.JWSInvalid)("at least one signature must be added");
        const jws = {
            signatures: [],
            payload: ""
        };
        for(let i = 0; i < this._signatures.length; i++){
            const signature = this._signatures[i];
            const flattened = new (0, _signJs.FlattenedSign)(this._payload);
            flattened.setProtectedHeader(signature.protectedHeader);
            flattened.setUnprotectedHeader(signature.unprotectedHeader);
            const { payload, ...rest } = await flattened.sign(signature.key, signature.options);
            if (i === 0) jws.payload = payload;
            else if (jws.payload !== payload) throw new (0, _errorsJs.JWSInvalid)("inconsistent use of JWS Unencoded Payload (RFC7797)");
            jws.signatures.push(rest);
        }
        return jws;
    }
}

},{"../flattened/sign.js":"lqvdz","../../util/errors.js":"4fsOp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ix6nL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SignJWT", ()=>SignJWT);
var _signJs = require("../jws/compact/sign.js");
var _errorsJs = require("../util/errors.js");
var _bufferUtilsJs = require("../lib/buffer_utils.js");
var _produceJs = require("./produce.js");
class SignJWT extends (0, _produceJs.ProduceJWT) {
    setProtectedHeader(protectedHeader) {
        this._protectedHeader = protectedHeader;
        return this;
    }
    async sign(key, options) {
        var _a;
        const sig = new (0, _signJs.CompactSign)((0, _bufferUtilsJs.encoder).encode(JSON.stringify(this._payload)));
        sig.setProtectedHeader(this._protectedHeader);
        if (Array.isArray((_a = this._protectedHeader) === null || _a === void 0 ? void 0 : _a.crit) && this._protectedHeader.crit.includes("b64") && this._protectedHeader.b64 === false) throw new (0, _errorsJs.JWTInvalid)("JWTs MUST NOT use unencoded payload");
        return sig.sign(key, options);
    }
}

},{"../jws/compact/sign.js":"4n4CU","../util/errors.js":"4fsOp","../lib/buffer_utils.js":"h0x9u","./produce.js":"9X7QN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9X7QN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProduceJWT", ()=>ProduceJWT);
var _epochJs = require("../lib/epoch.js");
var _epochJsDefault = parcelHelpers.interopDefault(_epochJs);
var _isObjectJs = require("../lib/is_object.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _secsJs = require("../lib/secs.js");
var _secsJsDefault = parcelHelpers.interopDefault(_secsJs);
class ProduceJWT {
    constructor(payload){
        if (!(0, _isObjectJsDefault.default)(payload)) throw new TypeError("JWT Claims Set MUST be an object");
        this._payload = payload;
    }
    setIssuer(issuer) {
        this._payload = {
            ...this._payload,
            iss: issuer
        };
        return this;
    }
    setSubject(subject) {
        this._payload = {
            ...this._payload,
            sub: subject
        };
        return this;
    }
    setAudience(audience) {
        this._payload = {
            ...this._payload,
            aud: audience
        };
        return this;
    }
    setJti(jwtId) {
        this._payload = {
            ...this._payload,
            jti: jwtId
        };
        return this;
    }
    setNotBefore(input) {
        if (typeof input === "number") this._payload = {
            ...this._payload,
            nbf: input
        };
        else this._payload = {
            ...this._payload,
            nbf: (0, _epochJsDefault.default)(new Date()) + (0, _secsJsDefault.default)(input)
        };
        return this;
    }
    setExpirationTime(input) {
        if (typeof input === "number") this._payload = {
            ...this._payload,
            exp: input
        };
        else this._payload = {
            ...this._payload,
            exp: (0, _epochJsDefault.default)(new Date()) + (0, _secsJsDefault.default)(input)
        };
        return this;
    }
    setIssuedAt(input) {
        if (typeof input === "undefined") this._payload = {
            ...this._payload,
            iat: (0, _epochJsDefault.default)(new Date())
        };
        else this._payload = {
            ...this._payload,
            iat: input
        };
        return this;
    }
}

},{"../lib/epoch.js":"htxcB","../lib/is_object.js":"daSnu","../lib/secs.js":"55mqE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"0M0j5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EncryptJWT", ()=>EncryptJWT);
var _encryptJs = require("../jwe/compact/encrypt.js");
var _bufferUtilsJs = require("../lib/buffer_utils.js");
var _produceJs = require("./produce.js");
class EncryptJWT extends (0, _produceJs.ProduceJWT) {
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setKeyManagementParameters(parameters) {
        if (this._keyManagementParameters) throw new TypeError("setKeyManagementParameters can only be called once");
        this._keyManagementParameters = parameters;
        return this;
    }
    setContentEncryptionKey(cek) {
        if (this._cek) throw new TypeError("setContentEncryptionKey can only be called once");
        this._cek = cek;
        return this;
    }
    setInitializationVector(iv) {
        if (this._iv) throw new TypeError("setInitializationVector can only be called once");
        this._iv = iv;
        return this;
    }
    replicateIssuerAsHeader() {
        this._replicateIssuerAsHeader = true;
        return this;
    }
    replicateSubjectAsHeader() {
        this._replicateSubjectAsHeader = true;
        return this;
    }
    replicateAudienceAsHeader() {
        this._replicateAudienceAsHeader = true;
        return this;
    }
    async encrypt(key, options) {
        const enc = new (0, _encryptJs.CompactEncrypt)((0, _bufferUtilsJs.encoder).encode(JSON.stringify(this._payload)));
        if (this._replicateIssuerAsHeader) this._protectedHeader = {
            ...this._protectedHeader,
            iss: this._payload.iss
        };
        if (this._replicateSubjectAsHeader) this._protectedHeader = {
            ...this._protectedHeader,
            sub: this._payload.sub
        };
        if (this._replicateAudienceAsHeader) this._protectedHeader = {
            ...this._protectedHeader,
            aud: this._payload.aud
        };
        enc.setProtectedHeader(this._protectedHeader);
        if (this._iv) enc.setInitializationVector(this._iv);
        if (this._cek) enc.setContentEncryptionKey(this._cek);
        if (this._keyManagementParameters) enc.setKeyManagementParameters(this._keyManagementParameters);
        return enc.encrypt(key, options);
    }
}

},{"../jwe/compact/encrypt.js":"2Mv4N","../lib/buffer_utils.js":"h0x9u","./produce.js":"9X7QN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dM89g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateJwkThumbprint", ()=>calculateJwkThumbprint);
parcelHelpers.export(exports, "calculateJwkThumbprintUri", ()=>calculateJwkThumbprintUri);
var _digestJs = require("../runtime/digest.js");
var _digestJsDefault = parcelHelpers.interopDefault(_digestJs);
var _base64UrlJs = require("../runtime/base64url.js");
var _errorsJs = require("../util/errors.js");
var _bufferUtilsJs = require("../lib/buffer_utils.js");
var _isObjectJs = require("../lib/is_object.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
const check = (value, description)=>{
    if (typeof value !== "string" || !value) throw new (0, _errorsJs.JWKInvalid)(`${description} missing or invalid`);
};
async function calculateJwkThumbprint(jwk, digestAlgorithm) {
    if (!(0, _isObjectJsDefault.default)(jwk)) throw new TypeError("JWK must be an object");
    digestAlgorithm !== null && digestAlgorithm !== void 0 ? digestAlgorithm : digestAlgorithm = "sha256";
    if (digestAlgorithm !== "sha256" && digestAlgorithm !== "sha384" && digestAlgorithm !== "sha512") throw new TypeError('digestAlgorithm must one of "sha256", "sha384", or "sha512"');
    let components;
    switch(jwk.kty){
        case "EC":
            check(jwk.crv, '"crv" (Curve) Parameter');
            check(jwk.x, '"x" (X Coordinate) Parameter');
            check(jwk.y, '"y" (Y Coordinate) Parameter');
            components = {
                crv: jwk.crv,
                kty: jwk.kty,
                x: jwk.x,
                y: jwk.y
            };
            break;
        case "OKP":
            check(jwk.crv, '"crv" (Subtype of Key Pair) Parameter');
            check(jwk.x, '"x" (Public Key) Parameter');
            components = {
                crv: jwk.crv,
                kty: jwk.kty,
                x: jwk.x
            };
            break;
        case "RSA":
            check(jwk.e, '"e" (Exponent) Parameter');
            check(jwk.n, '"n" (Modulus) Parameter');
            components = {
                e: jwk.e,
                kty: jwk.kty,
                n: jwk.n
            };
            break;
        case "oct":
            check(jwk.k, '"k" (Key Value) Parameter');
            components = {
                k: jwk.k,
                kty: jwk.kty
            };
            break;
        default:
            throw new (0, _errorsJs.JOSENotSupported)('"kty" (Key Type) Parameter missing or unsupported');
    }
    const data = (0, _bufferUtilsJs.encoder).encode(JSON.stringify(components));
    return (0, _base64UrlJs.encode)(await (0, _digestJsDefault.default)(digestAlgorithm, data));
}
async function calculateJwkThumbprintUri(jwk, digestAlgorithm) {
    digestAlgorithm !== null && digestAlgorithm !== void 0 ? digestAlgorithm : digestAlgorithm = "sha256";
    const thumbprint = await calculateJwkThumbprint(jwk, digestAlgorithm);
    return `urn:ietf:params:oauth:jwk-thumbprint:sha-${digestAlgorithm.slice(-3)}:${thumbprint}`;
}

},{"../runtime/digest.js":"hdTL7","../runtime/base64url.js":"8Djx4","../util/errors.js":"4fsOp","../lib/buffer_utils.js":"h0x9u","../lib/is_object.js":"daSnu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kUHEj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EmbeddedJWK", ()=>EmbeddedJWK);
var _importJs = require("../key/import.js");
var _isObjectJs = require("../lib/is_object.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _errorsJs = require("../util/errors.js");
async function EmbeddedJWK(protectedHeader, token) {
    const joseHeader = {
        ...protectedHeader,
        ...token === null || token === void 0 ? void 0 : token.header
    };
    if (!(0, _isObjectJsDefault.default)(joseHeader.jwk)) throw new (0, _errorsJs.JWSInvalid)('"jwk" (JSON Web Key) Header Parameter must be a JSON object');
    const key = await (0, _importJs.importJWK)({
        ...joseHeader.jwk,
        ext: true
    }, joseHeader.alg, true);
    if (key instanceof Uint8Array || key.type !== "public") throw new (0, _errorsJs.JWSInvalid)('"jwk" (JSON Web Key) Header Parameter must be a public key');
    return key;
}

},{"../key/import.js":"661YL","../lib/is_object.js":"daSnu","../util/errors.js":"4fsOp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gZQHZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isJWKSLike", ()=>isJWKSLike);
parcelHelpers.export(exports, "LocalJWKSet", ()=>LocalJWKSet);
parcelHelpers.export(exports, "createLocalJWKSet", ()=>createLocalJWKSet);
var _importJs = require("../key/import.js");
var _errorsJs = require("../util/errors.js");
var _isObjectJs = require("../lib/is_object.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
function getKtyFromAlg(alg) {
    switch(typeof alg === "string" && alg.slice(0, 2)){
        case "RS":
        case "PS":
            return "RSA";
        case "ES":
            return "EC";
        case "Ed":
            return "OKP";
        default:
            throw new (0, _errorsJs.JOSENotSupported)('Unsupported "alg" value for a JSON Web Key Set');
    }
}
function isJWKSLike(jwks) {
    return jwks && typeof jwks === "object" && Array.isArray(jwks.keys) && jwks.keys.every(isJWKLike);
}
function isJWKLike(key) {
    return (0, _isObjectJsDefault.default)(key);
}
function clone(obj) {
    if (typeof structuredClone === "function") return structuredClone(obj);
    return JSON.parse(JSON.stringify(obj));
}
class LocalJWKSet {
    constructor(jwks){
        this._cached = new WeakMap();
        if (!isJWKSLike(jwks)) throw new (0, _errorsJs.JWKSInvalid)("JSON Web Key Set malformed");
        this._jwks = clone(jwks);
    }
    async getKey(protectedHeader, token) {
        const { alg, kid } = {
            ...protectedHeader,
            ...token === null || token === void 0 ? void 0 : token.header
        };
        const kty = getKtyFromAlg(alg);
        const candidates = this._jwks.keys.filter((jwk)=>{
            let candidate = kty === jwk.kty;
            if (candidate && typeof kid === "string") candidate = kid === jwk.kid;
            if (candidate && typeof jwk.alg === "string") candidate = alg === jwk.alg;
            if (candidate && typeof jwk.use === "string") candidate = jwk.use === "sig";
            if (candidate && Array.isArray(jwk.key_ops)) candidate = jwk.key_ops.includes("verify");
            if (candidate && alg === "EdDSA") candidate = jwk.crv === "Ed25519" || jwk.crv === "Ed448";
            if (candidate) switch(alg){
                case "ES256":
                    candidate = jwk.crv === "P-256";
                    break;
                case "ES256K":
                    candidate = jwk.crv === "secp256k1";
                    break;
                case "ES384":
                    candidate = jwk.crv === "P-384";
                    break;
                case "ES512":
                    candidate = jwk.crv === "P-521";
                    break;
            }
            return candidate;
        });
        const { 0: jwk, length } = candidates;
        if (length === 0) throw new (0, _errorsJs.JWKSNoMatchingKey)();
        else if (length !== 1) {
            const error = new (0, _errorsJs.JWKSMultipleMatchingKeys)();
            const { _cached } = this;
            error[Symbol.asyncIterator] = async function*() {
                for (const jwk of candidates)try {
                    yield await importWithAlgCache(_cached, jwk, alg);
                } catch (_a) {
                    continue;
                }
            };
            throw error;
        }
        return importWithAlgCache(this._cached, jwk, alg);
    }
}
async function importWithAlgCache(cache, jwk, alg) {
    const cached = cache.get(jwk) || cache.set(jwk, {}).get(jwk);
    if (cached[alg] === undefined) {
        const key = await (0, _importJs.importJWK)({
            ...jwk,
            ext: true
        }, alg);
        if (key instanceof Uint8Array || key.type !== "public") throw new (0, _errorsJs.JWKSInvalid)("JSON Web Key Set members must be public keys");
        cached[alg] = key;
    }
    return cached[alg];
}
function createLocalJWKSet(jwks) {
    const set = new LocalJWKSet(jwks);
    return async function(protectedHeader, token) {
        return set.getKey(protectedHeader, token);
    };
}

},{"../key/import.js":"661YL","../util/errors.js":"4fsOp","../lib/is_object.js":"daSnu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gn9Cj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createRemoteJWKSet", ()=>createRemoteJWKSet);
var _fetchJwksJs = require("../runtime/fetch_jwks.js");
var _fetchJwksJsDefault = parcelHelpers.interopDefault(_fetchJwksJs);
var _errorsJs = require("../util/errors.js");
var _localJs = require("./local.js");
function isCloudflareWorkers() {
    return typeof WebSocketPair !== "undefined" || typeof navigator !== "undefined" && navigator.userAgent === "Cloudflare-Workers" || typeof EdgeRuntime !== "undefined" && EdgeRuntime === "vercel";
}
class RemoteJWKSet extends (0, _localJs.LocalJWKSet) {
    constructor(url, options){
        super({
            keys: []
        });
        this._jwks = undefined;
        if (!(url instanceof URL)) throw new TypeError("url must be an instance of URL");
        this._url = new URL(url.href);
        this._options = {
            agent: options === null || options === void 0 ? void 0 : options.agent,
            headers: options === null || options === void 0 ? void 0 : options.headers
        };
        this._timeoutDuration = typeof (options === null || options === void 0 ? void 0 : options.timeoutDuration) === "number" ? options === null || options === void 0 ? void 0 : options.timeoutDuration : 5000;
        this._cooldownDuration = typeof (options === null || options === void 0 ? void 0 : options.cooldownDuration) === "number" ? options === null || options === void 0 ? void 0 : options.cooldownDuration : 30000;
        this._cacheMaxAge = typeof (options === null || options === void 0 ? void 0 : options.cacheMaxAge) === "number" ? options === null || options === void 0 ? void 0 : options.cacheMaxAge : 600000;
    }
    coolingDown() {
        return typeof this._jwksTimestamp === "number" ? Date.now() < this._jwksTimestamp + this._cooldownDuration : false;
    }
    fresh() {
        return typeof this._jwksTimestamp === "number" ? Date.now() < this._jwksTimestamp + this._cacheMaxAge : false;
    }
    async getKey(protectedHeader, token) {
        if (!this._jwks || !this.fresh()) await this.reload();
        try {
            return await super.getKey(protectedHeader, token);
        } catch (err) {
            if (err instanceof (0, _errorsJs.JWKSNoMatchingKey)) {
                if (this.coolingDown() === false) {
                    await this.reload();
                    return super.getKey(protectedHeader, token);
                }
            }
            throw err;
        }
    }
    async reload() {
        if (this._pendingFetch && isCloudflareWorkers()) this._pendingFetch = undefined;
        this._pendingFetch || (this._pendingFetch = (0, _fetchJwksJsDefault.default)(this._url, this._timeoutDuration, this._options).then((json)=>{
            if (!(0, _localJs.isJWKSLike)(json)) throw new (0, _errorsJs.JWKSInvalid)("JSON Web Key Set malformed");
            this._jwks = {
                keys: json.keys
            };
            this._jwksTimestamp = Date.now();
            this._pendingFetch = undefined;
        }).catch((err)=>{
            this._pendingFetch = undefined;
            throw err;
        }));
        await this._pendingFetch;
    }
}
function createRemoteJWKSet(url, options) {
    const set = new RemoteJWKSet(url, options);
    return async function(protectedHeader, token) {
        return set.getKey(protectedHeader, token);
    };
}

},{"../runtime/fetch_jwks.js":"ev1hB","../util/errors.js":"4fsOp","./local.js":"gZQHZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ev1hB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _errorsJs = require("../util/errors.js");
const fetchJwks = async (url, timeout, options)=>{
    let controller;
    let id;
    let timedOut = false;
    if (typeof AbortController === "function") {
        controller = new AbortController();
        id = setTimeout(()=>{
            timedOut = true;
            controller.abort();
        }, timeout);
    }
    const response = await fetch(url.href, {
        signal: controller ? controller.signal : undefined,
        redirect: "manual",
        headers: options.headers
    }).catch((err)=>{
        if (timedOut) throw new (0, _errorsJs.JWKSTimeout)();
        throw err;
    });
    if (id !== undefined) clearTimeout(id);
    if (response.status !== 200) throw new (0, _errorsJs.JOSEError)("Expected 200 OK from the JSON Web Key Set HTTP response");
    try {
        return await response.json();
    } catch (_a) {
        throw new (0, _errorsJs.JOSEError)("Failed to parse the JSON Web Key Set HTTP response as JSON");
    }
};
exports.default = fetchJwks;

},{"../util/errors.js":"4fsOp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8DlpU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UnsecuredJWT", ()=>UnsecuredJWT);
var _base64UrlJs = require("../runtime/base64url.js");
var _bufferUtilsJs = require("../lib/buffer_utils.js");
var _errorsJs = require("../util/errors.js");
var _jwtClaimsSetJs = require("../lib/jwt_claims_set.js");
var _jwtClaimsSetJsDefault = parcelHelpers.interopDefault(_jwtClaimsSetJs);
var _produceJs = require("./produce.js");
class UnsecuredJWT extends (0, _produceJs.ProduceJWT) {
    encode() {
        const header = _base64UrlJs.encode(JSON.stringify({
            alg: "none"
        }));
        const payload = _base64UrlJs.encode(JSON.stringify(this._payload));
        return `${header}.${payload}.`;
    }
    static decode(jwt, options) {
        if (typeof jwt !== "string") throw new (0, _errorsJs.JWTInvalid)("Unsecured JWT must be a string");
        const { 0: encodedHeader, 1: encodedPayload, 2: signature, length } = jwt.split(".");
        if (length !== 3 || signature !== "") throw new (0, _errorsJs.JWTInvalid)("Invalid Unsecured JWT");
        let header;
        try {
            header = JSON.parse((0, _bufferUtilsJs.decoder).decode(_base64UrlJs.decode(encodedHeader)));
            if (header.alg !== "none") throw new Error();
        } catch (_a) {
            throw new (0, _errorsJs.JWTInvalid)("Invalid Unsecured JWT");
        }
        const payload = (0, _jwtClaimsSetJsDefault.default)(header, _base64UrlJs.decode(encodedPayload), options);
        return {
            payload,
            header
        };
    }
}

},{"../runtime/base64url.js":"8Djx4","../lib/buffer_utils.js":"h0x9u","../util/errors.js":"4fsOp","../lib/jwt_claims_set.js":"eRU3a","./produce.js":"9X7QN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kBsUQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decodeProtectedHeader", ()=>decodeProtectedHeader);
var _base64UrlJs = require("./base64url.js");
var _bufferUtilsJs = require("../lib/buffer_utils.js");
var _isObjectJs = require("../lib/is_object.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
function decodeProtectedHeader(token) {
    let protectedB64u;
    if (typeof token === "string") {
        const parts = token.split(".");
        if (parts.length === 3 || parts.length === 5) [protectedB64u] = parts;
    } else if (typeof token === "object" && token) {
        if ("protected" in token) protectedB64u = token.protected;
        else throw new TypeError("Token does not contain a Protected Header");
    }
    try {
        if (typeof protectedB64u !== "string" || !protectedB64u) throw new Error();
        const result = JSON.parse((0, _bufferUtilsJs.decoder).decode((0, _base64UrlJs.decode)(protectedB64u)));
        if (!(0, _isObjectJsDefault.default)(result)) throw new Error();
        return result;
    } catch (_a) {
        throw new TypeError("Invalid Token or Protected Header formatting");
    }
}

},{"./base64url.js":"bljA2","../lib/buffer_utils.js":"h0x9u","../lib/is_object.js":"daSnu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bljA2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "encode", ()=>encode);
parcelHelpers.export(exports, "decode", ()=>decode);
var _base64UrlJs = require("../runtime/base64url.js");
const encode = _base64UrlJs.encode;
const decode = _base64UrlJs.decode;

},{"../runtime/base64url.js":"8Djx4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aGTXa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decodeJwt", ()=>decodeJwt);
var _base64UrlJs = require("./base64url.js");
var _bufferUtilsJs = require("../lib/buffer_utils.js");
var _isObjectJs = require("../lib/is_object.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _errorsJs = require("./errors.js");
function decodeJwt(jwt) {
    if (typeof jwt !== "string") throw new (0, _errorsJs.JWTInvalid)("JWTs must use Compact JWS serialization, JWT must be a string");
    const { 1: payload, length } = jwt.split(".");
    if (length === 5) throw new (0, _errorsJs.JWTInvalid)("Only JWTs using Compact JWS serialization can be decoded");
    if (length !== 3) throw new (0, _errorsJs.JWTInvalid)("Invalid JWT");
    if (!payload) throw new (0, _errorsJs.JWTInvalid)("JWTs must contain a payload");
    let decoded;
    try {
        decoded = (0, _base64UrlJs.decode)(payload);
    } catch (_a) {
        throw new (0, _errorsJs.JWTInvalid)("Failed to base64url decode the payload");
    }
    let result;
    try {
        result = JSON.parse((0, _bufferUtilsJs.decoder).decode(decoded));
    } catch (_b) {
        throw new (0, _errorsJs.JWTInvalid)("Failed to parse the decoded payload as JSON");
    }
    if (!(0, _isObjectJsDefault.default)(result)) throw new (0, _errorsJs.JWTInvalid)("Invalid JWT Claims Set");
    return result;
}

},{"./base64url.js":"bljA2","../lib/buffer_utils.js":"h0x9u","../lib/is_object.js":"daSnu","./errors.js":"4fsOp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h6CYR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateKeyPair", ()=>generateKeyPair);
var _generateJs = require("../runtime/generate.js");
async function generateKeyPair(alg, options) {
    return (0, _generateJs.generateKeyPair)(alg, options);
}

},{"../runtime/generate.js":"gDjpj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gDjpj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateSecret", ()=>generateSecret);
parcelHelpers.export(exports, "generateKeyPair", ()=>generateKeyPair);
var _webcryptoJs = require("./webcrypto.js");
var _webcryptoJsDefault = parcelHelpers.interopDefault(_webcryptoJs);
var _errorsJs = require("../util/errors.js");
var _randomJs = require("./random.js");
var _randomJsDefault = parcelHelpers.interopDefault(_randomJs);
async function generateSecret(alg, options) {
    var _a;
    let length;
    let algorithm;
    let keyUsages;
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            length = parseInt(alg.slice(-3), 10);
            algorithm = {
                name: "HMAC",
                hash: `SHA-${length}`,
                length
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            length = parseInt(alg.slice(-3), 10);
            return (0, _randomJsDefault.default)(new Uint8Array(length >> 3));
        case "A128KW":
        case "A192KW":
        case "A256KW":
            length = parseInt(alg.slice(1, 4), 10);
            algorithm = {
                name: "AES-KW",
                length
            };
            keyUsages = [
                "wrapKey",
                "unwrapKey"
            ];
            break;
        case "A128GCMKW":
        case "A192GCMKW":
        case "A256GCMKW":
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            length = parseInt(alg.slice(1, 4), 10);
            algorithm = {
                name: "AES-GCM",
                length
            };
            keyUsages = [
                "encrypt",
                "decrypt"
            ];
            break;
        default:
            throw new (0, _errorsJs.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
    }
    return (0, _webcryptoJsDefault.default).subtle.generateKey(algorithm, (_a = options === null || options === void 0 ? void 0 : options.extractable) !== null && _a !== void 0 ? _a : false, keyUsages);
}
function getModulusLengthOption(options) {
    var _a;
    const modulusLength = (_a = options === null || options === void 0 ? void 0 : options.modulusLength) !== null && _a !== void 0 ? _a : 2048;
    if (typeof modulusLength !== "number" || modulusLength < 2048) throw new (0, _errorsJs.JOSENotSupported)("Invalid or unsupported modulusLength option provided, 2048 bits or larger keys must be used");
    return modulusLength;
}
async function generateKeyPair(alg, options) {
    var _a, _b, _c;
    let algorithm;
    let keyUsages;
    switch(alg){
        case "PS256":
        case "PS384":
        case "PS512":
            algorithm = {
                name: "RSA-PSS",
                hash: `SHA-${alg.slice(-3)}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: getModulusLengthOption(options)
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "RS256":
        case "RS384":
        case "RS512":
            algorithm = {
                name: "RSASSA-PKCS1-v1_5",
                hash: `SHA-${alg.slice(-3)}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: getModulusLengthOption(options)
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            algorithm = {
                name: "RSA-OAEP",
                hash: `SHA-${parseInt(alg.slice(-3), 10) || 1}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: getModulusLengthOption(options)
            };
            keyUsages = [
                "decrypt",
                "unwrapKey",
                "encrypt",
                "wrapKey"
            ];
            break;
        case "ES256":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-256"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "ES384":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-384"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "ES512":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-521"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "EdDSA":
            keyUsages = [
                "sign",
                "verify"
            ];
            const crv = (_a = options === null || options === void 0 ? void 0 : options.crv) !== null && _a !== void 0 ? _a : "Ed25519";
            switch(crv){
                case "Ed25519":
                case "Ed448":
                    algorithm = {
                        name: crv
                    };
                    break;
                default:
                    throw new (0, _errorsJs.JOSENotSupported)("Invalid or unsupported crv option provided");
            }
            break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                keyUsages = [
                    "deriveKey",
                    "deriveBits"
                ];
                const crv = (_b = options === null || options === void 0 ? void 0 : options.crv) !== null && _b !== void 0 ? _b : "P-256";
                switch(crv){
                    case "P-256":
                    case "P-384":
                    case "P-521":
                        algorithm = {
                            name: "ECDH",
                            namedCurve: crv
                        };
                        break;
                    case "X25519":
                    case "X448":
                        algorithm = {
                            name: crv
                        };
                        break;
                    default:
                        throw new (0, _errorsJs.JOSENotSupported)("Invalid or unsupported crv option provided, supported values are P-256, P-384, P-521, X25519, and X448");
                }
                break;
            }
        default:
            throw new (0, _errorsJs.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
    }
    return (0, _webcryptoJsDefault.default).subtle.generateKey(algorithm, (_c = options === null || options === void 0 ? void 0 : options.extractable) !== null && _c !== void 0 ? _c : false, keyUsages);
}

},{"./webcrypto.js":"aUHBb","../util/errors.js":"4fsOp","./random.js":"4nPoE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jmQID":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateSecret", ()=>generateSecret);
var _generateJs = require("../runtime/generate.js");
async function generateSecret(alg, options) {
    return (0, _generateJs.generateSecret)(alg, options);
}

},{"../runtime/generate.js":"gDjpj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l9K66":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _runtimeJs = require("../runtime/runtime.js");
var _runtimeJsDefault = parcelHelpers.interopDefault(_runtimeJs);
exports.default = (0, _runtimeJsDefault.default);

},{"../runtime/runtime.js":"jOm8H","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jOm8H":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = "WebCryptoAPI";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jCXmG":[function(require,module,exports) {
module.exports = require("85ca41a4cefc5905")(require("3bc3c00f30e1a1a4").resolve("joS1N")).then(()=>module.bundle.root("fRpeL"));

},{"85ca41a4cefc5905":"hpx0h","3bc3c00f30e1a1a4":"fyJL2"}],"hpx0h":[function(require,module,exports) {
"use strict";
var cacheLoader = require("ca2a84f7fa4a3bb0");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

},{"ca2a84f7fa4a3bb0":"1uYxD"}],"1uYxD":[function(require,module,exports) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case "preload":
            return cachedPreloads;
        case "prefetch":
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"cUaV9":[function(require,module,exports) {
module.exports = require("dfb3980264b9a375")(require("834bed7596d2bea5").resolve("g9O5g")).then(()=>module.bundle.root("7jSY4"));

},{"dfb3980264b9a375":"hpx0h","834bed7596d2bea5":"fyJL2"}]},["gb59R","8RSWf"], "8RSWf", "parcelRequire819c")

//# sourceMappingURL=index.js.map
